<template>
  <div>
    <material-button
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#modalAddItem"
      id="show-modal-add-item"
    ></material-button>
    <material-button
      class="d-none"
      data-bs-dismiss="modal"
      data-bs-target="#modalAddItem"
      id="hide-modal-add-item"
    ></material-button>
    <div id="custom-overlay" class="custom-modal-overlay"></div>
    <div class="modal fade" id="modalAddItem" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

          <!-- ✅ CHANGE 1: modal-header uses flex-wrap so title + retail toggle stack on mobile -->
          <div class="modal-header flex-wrap gap-2 position-relative custom-modal-header">
            <div class="d-flex flex-wrap align-items-center gap-2 flex-grow-1" style="padding-right: 30px;">
              <h5 class="modal-title mb-0">
                {{ isEditItem ? "Edit Item" : "Add Item" }}
              </h5>
              <div v-if="isInventoryItem || menusetId !== 0" class="d-flex align-items-center justify-items-start ms-sm-3">
                <div class="me-2 fw-bold" style="margin-top: 3px;">Retail mode</div>
                <div
                  :class="{ active: isRetailMode }"
                  class="toggle_container"
                >
                  <MaterialToggleButton
                    labelEnableText=""
                    labelDisableText=""
                    id="retail_mode_toggle"
                    :defaultState="isRetailMode"
                    v-on:change="triggerEventRetailMode"
                    class="mb-0"
                    style="height: 25.5px !important;"
                  />
                </div>
              </div>
              <div class="d-flex align-items-center justify-items-start ms-sm-3">
                <div class="me-2 fw-bold" style="margin-top: 3px;">Eligible BCRS</div>
                <div
                  :class="{ active: isEligibleBCRS }"
                  class="toggle_container"
                >
                  <MaterialToggleButton
                    labelEnableText=""
                    labelDisableText=""
                    id="eligible_bcrs_toggle"
                    :defaultState="isEligibleBCRS"
                    v-on:change="triggerEventEligibleBCRS"
                    class="mb-0"
                    style="height: 25.5px !important;"
                  />
                </div>
              </div>
            </div>
            <i
              class="material-icons btn-close-modal modal-close-x"
              data-bs-dismiss="modal"
              >clear</i
            >
          </div>

          <div class="modal-body position-relative pt-0" @scroll="handleScroll">

            <!-- ✅ CHANGE 2: nav tabs wrapper supports horizontal scroll on mobile -->
            <div
              class="menu-top"
              style="
                position: sticky;
                top: 0;
                background-color: white;
                z-index: 9999;
                overflow-x: auto;
              "
            >
              <ul id="general-tab" class="nav nav-tabs pe-0 w-100" style="flex-wrap: nowrap; min-width: max-content;">
                <li class="nav-item">
                  <a
                    :id="'nav_edit_item_1'"
                    class="nav-link active nav-edit-item"
                    @click="changeTab(1, 'main-section')"
                  >
                    <div class="mt-1">MAIN</div>
                  </a>
                </li>
                <li
                  class="nav-item nav-edit-item"
                >
                  <a
                    :id="'nav_edit_item_2'"
                    class="nav-link nav-edit-item"
                    @click="changeTab(2, 'prices-section')"
                  >
                    <div class="mt-1">PRICES</div></a
                  >
                </li>
                <li v-if="isRetailMode" class="nav-item nav-edit-item">
                  <a
                    :id="'nav_edit_item_3'"
                    class="nav-link nav-edit-item"
                    @click="changeTab(3, 'cost-section')"
                  >
                    <div class="mt-1">COST</div></a
                  >
                </li>
                <li class="nav-item nav-edit-item">
                  <a
                    :id="'nav_edit_item_3'"
                    class="nav-link nav-edit-item"
                    @click="changeTab(3, 'pos-setting-section')"
                  >
                    <div class="mt-1">POS Setting</div></a
                  >
                </li>
                <!-- <li class="nav-item nav-edit-item" v-if="isEditItem">
                  <a
                    :id="'nav_edit_item_5'"
                    class="nav-link nav-edit-item"
                    @click="changeTab(5, 'inventory-section')"
                  >
                    <div class="mt-1">INVENTORY</div></a
                  >
                </li> -->
                <li v-if="!isRetailMode" class="nav-item nav-edit-item">
                  <a
                    :id="'nav_edit_item_4'"
                    class="nav-link nav-edit-item"
                    @click="changeTab(4, 'choice-section')"
                  >
                    <div class="mt-1">ITEMS MODE</div></a
                  >
                </li>
              </ul>
            </div>

            <div>
              <div id="main-section">
                <div class="content-center">
                  <h3
                    class="title-page fs-16 mb-0 mt-3 cursor-pointer section-header"
                    @click="showHideSection(1)"
                  >
                    MAIN
                  </h3>
                  <!-- <div class="d-flex align-items-center mt-3">
                      <label class="fw-bold mb-0 mt-1 me-3" for>Enable</label>
                      <div class="d-flex">
                        <div
                          :class="{ active: !item.is_disabled }"
                          class="toggle_container pt-1"
                        >
                          <MaterialToggleButton
                            labelEnableText
                            labelDisableText
                            id="event_handle_2"
                            v-on:change="triggerEvent"
                            class="mb-0"
                          />
                        </div>
                      </div>
                    </div> -->
                  <div class="row mt-3 item-image-container">
                    <div class="col-lg-6 col-12">
                      <label class="fw-bold" for>
                        Item No
                        <span class="text-danger ms-2">*</span>
                      </label>
                      <material-input
                        v-model="item.item_no"
                        type="text"
                        id="item_no"
                        name="item_no"
                        @input="inputItemNo()"
                      />
                      <span
                        class="is-invalid"
                        v-if="fieldRequired.isItemNameNoRequired"
                        >The field is required.</span
                      >
                    </div>
                    <!-- ✅ CHANGE 3: image column gets top spacing on mobile -->
                    <div class="col-lg-6 col-12 mt-3 mt-lg-0">
                      <div
                        class="dowload-img"
                        v-show="urlImagePreview"
                        style="
                          width: 100px !important;
                          height: 100px !important;
                        "
                      >
                        <div id="preview" style="position: relative">
                          <img
                            class="image-url"
                            style="
                              width: 100px !important;
                              height: 100px !important;
                            "
                            v-if="urlImagePreview"
                            :src="urlImagePreview"
                          />
                          <i
                            class="fa fa-times icon-close-sidenav-main danger"
                            v-if="urlImagePreview"
                            style="
                              position: absolute;
                              color: #f44335;
                              font-size: 24px;
                              right: 5px;
                              top: 6px;
                            "
                            aria-hidden="true"
                            @click="clearImage()"
                          ></i>
                          <div class="btn-edit-img">
                            <i
                              class="fas fa-pencil-alt text-dark"
                              v-if="urlImagePreview"
                              aria-hidden="true"
                              @click="uploadFile('image-item')"
                            ></i>
                          </div>
                        </div>
                      </div>
                      <div
                        class="d-flex align-items-center"
                        :class="{ 'd-none': urlImagePreview }"
                      >
                        <div
                          class="dowload-img"
                          style="
                            width: 100px !important;
                            height: 100px !important;
                            border-radius: 50%;
                          "
                          @click="uploadFile('image-item')"
                        >
                          <material-input
                            style="display: none"
                            type="file"
                            id="image-item"
                            @change="handleFileUpload($event)"
                            accept="image/*"
                          />
                          <i class="material-icons css-icon-upload">backup</i>
                        </div>
                        <div>
                          <div class="ms-3 text-blue">800 x 800 pixels</div>
                          <div class="ms-3 text-blue">Up to 1MB</div>
                        </div>
                      </div>
                      <div
                        class="is-invalid d-flex align-items-center pe-2"
                        v-if="fieldRequired.isImageRequire"
                      >
                        {{ messageImageError }}
                      </div>
                    </div>
                  </div>
                  <div class="mt-3">
                    <a
                      @click="isShowBarcode = !isShowBarcode"
                      class="text-decoration-underline tag-a-custom"
                      >Add Barcodes
                    </a>
                  </div>
                  <div v-if="isShowBarcode">
                    <div class="mt-1">
                      <label class="fw-bold" for> Barcode </label>
                      <material-input
                        v-model="item.barcode"
                        type="text"
                        id="barcode"
                        name="barcode"
                      />
                    </div>
                    <div class="mt-1">
                      <label class="fw-bold" for> Barcode 2 </label>
                      <material-input
                        v-model="item.barcode2"
                        type="text"
                        id="barcode2"
                        name="barcode2"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="fw-bold" for>
                      Item Name
                      <span class="text-danger ms-2">*</span>
                      <span class="text-blue ms-2">(Displayed on Kiosk and QR ordering)</span>
                    </label>
                    <material-input
                      v-model="item.item_name"
                      type="text"
                      id="item_name"
                      name="item_name"
                      placeholder="Online ordering name"
                      @input="inputItemName()"
                    />
                    <span
                      class="is-invalid"
                      v-if="fieldRequired.isItemNameRequired"
                      >The field is required.</span
                    >
                  </div>
                  <div class="mt-3">
                    <div class="mt-3">
                      <div
                        class="d-flex justify-content-between align-items-center mb-2"
                      >
                        <label class="fw-bold mb-0" for>
                          Name 2 <span class="text-danger ms-2">*</span>
                          <span class="text-blue">
                            {{
                              menuSet?.id
                                ? ` (POS Eng Name. Default = ${
                                    menuSet.pos_name === 2
                                      ? "Description"
                                      : "Item Name"
                                  })`
                                : " (POS Eng Name. Default = Item Name)"
                            }}
                          </span>
                        </label>
                        <!-- <div class="d-flex align-items-center">
                          <material-checkbox
                            @change="checkboxChange(item.same_item_name, 'name')"
                            class="align-items-center checkbox-custom mb-0 ms-3"
                            v-model="item.same_item_name"
                            :checked="item.same_item_name"
                          ></material-checkbox>
                          <div class="mt-1 ms-2">Same as Item Name</div>
                        </div> -->
                      </div>
                      <material-input
                        v-model="item.pos_name"
                        type="text"
                        id="pos_name"
                        name="pos_name"
                        :placeholder="'Name in English. Print name on receipts'"
                      />
                      <span
                        class="is-invalid"
                        v-if="fieldRequired.isPosNameRequired"
                        >The field is required.</span
                      >
                    </div>
                    <div class="mt-3">
                      <div
                        class="d-flex justify-content-between align-items-center mb-2"
                      >
                        <label class="fw-bold mb-0" for>
                          Name 3
                          <span class="text-blue">
                            {{
                              menuSet?.id
                                ? ` (POS Name. Default = ${
                                    menuSet.pos_description === 2
                                      ? "Description"
                                      : "Item Name"
                                  })`
                                : " (POS Name. Default = Description)"
                            }}
                          </span>
                        </label>
                        <!-- <div class="d-flex align-items-center">
                          <material-checkbox
                            @change="
                              checkboxChange(
                                item.same_item_description,
                                'description'
                              )
                            "
                            class="align-items-center checkbox-custom mb-0 ms-3"
                            v-model="item.same_item_description"
                            :checked="item.same_item_description"
                          ></material-checkbox>
                          <div class="mt-1 ms-2">Same as Description</div>
                        </div> -->
                      </div>
                      <material-input
                        v-model="item.pos_description"
                        type="text"
                        id="pos_description"
                        name="pos_description"
                        :placeholder="'Alternative name. Often used for kitchen printing/display'"
                      />
                    </div>
                    <div class="mt-3">
                      <label class="fw-bold mb-0" for> Name 4 </label>
                      <material-input
                        v-model="item.item_name4"
                        type="text"
                        id="item_name4"
                        name="item_name4"
                        :placeholder="'Alternative name. Often used for kitchen printing/display'"
                      />
                    </div>
                    <!-- SF289: the official translations imported in SF288. Editable here so a
                         single item can be corrected without re-importing the whole sheet.
                         This modal is shared with Modifiers, so these also cover modifier options. -->
                    <div class="mt-3">
                      <label class="fw-bold mb-0" for> Chinese Name </label>
                      <material-input
                        v-model="item.item_name_zh"
                        type="text"
                        id="item_name_zh"
                        name="item_name_zh"
                        :placeholder="'Chinese name shown by the QR ordering language switch'"
                      />
                    </div>
                    <div class="mt-3">
                      <label class="fw-bold mb-0" for> Japanese Name </label>
                      <material-input
                        v-model="item.item_name_ja"
                        type="text"
                        id="item_name_ja"
                        name="item_name_ja"
                        :placeholder="'Japanese name shown by the QR ordering language switch'"
                      />
                    </div>
                    <div class="mt-3">
                      <label class="fw-bold mb-0" for> Korean Name </label>
                      <material-input
                        v-model="item.item_name_ko"
                        type="text"
                        id="item_name_ko"
                        name="item_name_ko"
                        :placeholder="'Korean name shown by the QR ordering language switch'"
                      />
                    </div>
                    <div class="mt-3">
                      <label class="fw-bold mb-0" for> Thai Name </label>
                      <material-input
                        v-model="item.item_name_th"
                        type="text"
                        id="item_name_th"
                        name="item_name_th"
                        :placeholder="'Thai name shown by the QR ordering language switch'"
                      />
                    </div>
                  </div>
                  <div class="mt-3">
                    <label class="fw-bold" for>
                      Description
                      <span class="text-blue ms-2">(Displayed on Kiosk and QR ordering)</span>
                    </label>
                    <material-input
                      v-model="item.description"
                      type="text"
                      id="item_description"
                      name="item_description"
                      placeholder="Ingredients, foreign language name etc"
                      @input="inputItemDescription()"
                    />
                  </div>
                  <!-- SH004: how long the service takes. Salon booking prints it on the
                       service card; 0 hides that chip, which is what every food &
                       beverage item keeps. -->
                  <div class="mt-3">
                    <label class="fw-bold" for>
                      Service duration (minutes)
                      <span class="text-blue ms-2"
                        >(Salon booking. Leave 0 if not a timed service)</span
                      >
                    </label>
                    <material-input
                      v-model="item.service_duration_min"
                      type="number"
                      id="service_duration_min"
                      name="service_duration_min"
                      placeholder="0"
                    />
                    <span
                      class="is-invalid"
                      v-if="fieldRequired.isItemServiceDurationRequired"
                      >Number must be between 0 and 1440.</span
                    >
                  </div>
                  <!-- SH027: the booking window and time slots of a salon service. They used
                       to live on the Service & Slot Setting screen, against a separate list of
                       "venues" the merchant had to keep in step with the menu by hand. Shown
                       only once the item is a timed service, so every food & beverage item and
                       every modifier option keeps the form it had. -->
                  <div v-if="isBookableService" class="mt-4 booking-slot-section">
                    <label class="fw-bold d-block mb-2">
                      Booking slot
                      <span class="text-blue ms-2">(Salon booking)</span>
                    </label>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label class="fw-bold" for>Min Booking In Advance Time</label>
                        <div class="d-flex">
                          <material-input
                            v-model="item.booking_min_advance_time"
                            type="number"
                            id="booking_min_advance_time"
                            name="booking_min_advance_time"
                            placeholder="0"
                          />
                          <Multiselect
                            v-model="item.booking_min_advance_time_unit"
                            :options="bookingAdvanceUnitOptions"
                            class="ms-3 booking-unit"
                            :canClear="false"
                          />
                        </div>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="fw-bold" for>Max Booking In Advance Time</label>
                        <div class="d-flex">
                          <material-input
                            v-model="item.booking_max_advance_time"
                            type="number"
                            id="booking_max_advance_time"
                            name="booking_max_advance_time"
                            placeholder="0"
                          />
                          <Multiselect
                            v-model="item.booking_max_advance_time_unit"
                            :options="bookingAdvanceUnitOptions"
                            class="ms-3 booking-unit"
                            :canClear="false"
                          />
                        </div>
                      </div>
                    </div>
                    <span
                      class="is-invalid"
                      v-if="fieldRequired.isBookingAdvanceTimeInvalid"
                      >Booking in advance time must be 0 or more.</span
                    >
                    <div class="d-flex justify-content-between align-items-center mt-2">
                      <label class="fw-bold mb-0" for>Time slots</label>
                      <a
                        class="text-decoration-underline tag-a-custom"
                        @click="addBookingSlot()"
                        >+ Add slot</a
                      >
                    </div>
                    <!-- A row rather than a table: the form column inside this modal is about
                         500px wide, and five table cells squeezed Day and Status down to a
                         clipped 56px. Two lines per slot fit that width and stay readable. -->
                    <div v-if="bookingSlots.length" class="mt-2">
                      <div
                        v-for="(slot, index) in bookingSlots"
                        :key="index"
                        class="booking-slot-row"
                      >
                        <div class="d-flex align-items-center">
                          <material-input
                            v-model="slot.name"
                            type="text"
                            class="flex-grow-1 mb-0"
                            placeholder="Slot name (e.g. Morning)"
                          />
                          <Multiselect
                            v-model="slot.status"
                            :options="bookingSlotStatusOptions"
                            :canClear="false"
                            class="booking-status ms-2"
                          />
                          <i
                            class="fas fa-trash-alt cursor-pointer ms-3"
                            @click="removeBookingSlot(index)"
                          ></i>
                        </div>
                        <span
                          class="is-invalid"
                          v-if="slot.fieldRequired.isNameRequire"
                          >The field is required.</span
                        >
                        <div class="d-flex align-items-center flex-wrap mt-2">
                          <Multiselect
                            v-model="slot.day_of_week"
                            :options="bookingDayOptions"
                            :canClear="false"
                            class="booking-day me-2"
                          />
                          <!-- A native time input rather than the Datepicker the old slot
                               screen used: its overlay is drawn full size over this modal and
                               a slot only ever needs a clock time, which type="time" hands
                               back as the "HH:mm" the API stores. -->
                          <input
                            type="time"
                            class="form-control booking-time"
                            v-model="slot.start_time"
                            aria-label="Slot start time"
                          />
                          <div class="mx-1">-</div>
                          <input
                            type="time"
                            class="form-control booking-time"
                            v-model="slot.end_time"
                            aria-label="Slot end time"
                          />
                        </div>
                        <span
                          class="is-invalid"
                          v-if="slot.fieldRequired.isTimeRequire"
                          >The field is required.</span
                        >
                      </div>
                    </div>
                    <div v-else class="text-center py-3 no-slot">
                      No time slot yet. The service is bookable in the outlet's opening hours.
                    </div>
                    <div class="mt-3">
                      <label class="fw-bold" for>Terms &amp; Conditions</label>
                      <material-textarea
                        rows="4"
                        v-model="item.booking_terms_conditions"
                      />
                    </div>
                  </div>
                  <div v-if="isRetailMode" class="mt-3">
                    <div
                      class="d-flex align-items-center justify-content-between mb-2"
                    >
                      <label class="fw-bold mb-0" for>Report Group <span class="text-danger ms-2">*</span></label>
                      <a
                        @click="gotoTypeAndGroupPage()"
                        class="text-decoration-underline tag-a-custom"
                        >Manage</a
                      >
                    </div>
                    <!-- ✅ CHANGE 4: Report Group dropdowns stack on mobile, inline on sm+ -->
                    <div class="d-flex flex-column flex-sm-row gap-2">
                      <Multiselect
                        v-model="item.type_id"
                        :options="types"
                        :canClear="false"
                        placeholder="Type"
                        @change="selectType"
                      />
                      <Multiselect
                        v-model="item.group_id"
                        :options="groups"
                        :canClear="false"
                        placeholder="Group"
                        :disabled="!item.type_id"
                      />
                    </div>
                    <span
                      class="is-invalid"
                      v-if="fieldRequired.isReportGroupRequired"
                      >The field is required.
                    </span>
                  </div>
                  <hr />
                </div>
              </div>
              <div id="prices-section">
                <div class="content-center">
                  <h3
                    class="title-page fs-16 mb-0 cursor-pointer section-header mt-3"
                    @click="showHideSection(2)"
                  >
                    PRICES
                  </h3>
                  <div
                    v-if="isChoiceOrSubCategory"
                    style="font-size: 14px; color: #007bff"
                    class="mt-3"
                  >
                    <div>This item has more than 1 variation.</div>
                    <div>
                      Go to Items Mode section to manage price for each choice.
                    </div>
                  </div>
                  <div v-else>
                    <div>
                      <div class="table-responsive p-0 mt-3">
                        <table
                          class="table align-items-center mb-0 table-fixed"
                          style="border: none"
                        >
                          <thead>
                            <tr>
                              <th class="w-35" style="border: none">
                                Description
                              </th>
                              <th class="w-20" style="border: none">Price</th>
                            </tr>
                          </thead>
                          <tbody style="border: none">
                            <template
                              v-for="(price, index) in isEditItem
                                ? item.others_price.slice(0, 2)
                                : item.others_price"
                              :key="index"
                            >
                              <tr
                                style="border: none"
                                :class="{
                                  'price-row-error': pricesError.includes(
                                    price.price_key
                                  ),
                                }"
                              >
                                <td class="tex-end" style="border: none">
                                  <span>
                                    {{
                                      memberPriceSelected.hasOwnProperty(
                                        price.price_key
                                      )
                                        ? "Member Price"
                                        : price.description
                                    }}
                                    <span
                                      v-if="price.price_key === 'price_1'"
                                      class="text-danger"
                                      >*</span
                                    >
                                  </span>
                                </td>
                                <td class="tex-end" style="border: none">
                                  <!-- ✅ CHANGE 5: price row content wraps on very small screens -->
                                  <div
                                    style="
                                      display: flex;
                                      align-items: center;
                                      gap: 10px;
                                      flex-wrap: wrap;
                                    "
                                  >
                                    <div
                                      style="display: flex; align-items: center"
                                    >
                                      <div
                                        style="
                                          margin-bottom: 5px;
                                          margin-right: 5px;
                                        "
                                      >
                                        $
                                      </div>
                                      <material-input
                                        @keydown.prevent.up="preventUpDown"
                                        @keydown.prevent.down="preventUpDown"
                                        v-model="price.price"
                                        :id="'other_price_' + index"
                                        :name="'other_price_' + index"
                                        type="number"
                                        step="any"
                                        size="lg"
                                        :class="{
                                          'price-error': pricesError.includes(
                                            price.price_key
                                          ),
                                        }"
                                        @input="inputItemPrice($event, index)"
                                      />
                                    </div>
                                    <div
                                      v-if="
                                        price.price == 0 &&
                                        (price.price_key === 'price_1' ||
                                          Object.prototype.hasOwnProperty.call(
                                            memberPriceSelected,
                                            price.price_key
                                          ))
                                      "
                                      class="d-flex align-items-center"
                                    >
                                      <input
                                        type="checkbox"
                                        :id="'zero_price_confirm_' + index"
                                        class="me-2"
                                        style="margin-right: 5px"
                                        :checked="priceSetAsZero.includes(price.price_key)"
                                        @change="
                                          clearPriceError(
                                            index,
                                            price.price_key,
                                            'price',
                                            $event
                                          )
                                        "
                                      />
                                      <label
                                        :for="'zero_price_confirm_' + index"
                                        class="mb-0 text-muted small"
                                      >
                                        Set as $0
                                      </label>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr
                                v-if="
                                  memberPriceSelected.hasOwnProperty(
                                    price.price_key
                                  )
                                "
                                style="border: none"
                              >
                                <td colspan="2" style="border: none">
                                  <div
                                    class="text-blue"
                                    style="white-space: normal; word-wrap: break-word;"
                                  >
                                    (Used as member price by
                                    {{
                                      memberPriceSelected[price.price_key].join(
                                        ", "
                                      )
                                    }})
                                  </div>
                                </td>
                              </tr>
                            </template>

                            <template v-if="isEditItem && showMorePrices">
                              <template
                                v-for="(
                                  price, index
                                ) in item.others_price.slice(2)"
                                :key="index + 2"
                              >
                                <tr
                                  style="border: none"
                                  :class="{
                                    'price-row-error': pricesError.includes(
                                      price.price_key
                                    ),
                                  }"
                                >
                                  <td class="tex-end" style="border: none">
                                    <span>
                                      {{ price.description }}
                                    </span>
                                  </td>
                                  <td class="tex-end" style="border: none">
                                    <div
                                      style="
                                        display: flex;
                                        align-items: center;
                                        gap: 10px;
                                        flex-wrap: wrap;
                                      "
                                    >
                                      <div
                                        style="
                                          display: flex;
                                          align-items: center;
                                        "
                                      >
                                        <div
                                          style="
                                            margin-bottom: 5px;
                                            margin-right: 5px;
                                          "
                                        >
                                          $
                                        </div>
                                        <material-input
                                          @keydown.prevent.up="preventUpDown"
                                          @keydown.prevent.down="preventUpDown"
                                          v-model="price.price"
                                          :id="'other_price_' + (index + 2)"
                                          :name="'other_price_' + (index + 2)"
                                          type="number"
                                          step="any"
                                          size="lg"
                                          :class="{
                                            'price-error': pricesError.includes(
                                              price.price_key
                                            ),
                                          }"
                                          @input="inputItemPrice($event, index + 2)"
                                        />
                                      </div>
                                      <div
                                        v-if="
                                          price.price == 0 &&
                                          (price.price_key === 'price_1' ||
                                            Object.prototype.hasOwnProperty.call(
                                              memberPriceSelected,
                                              price.price_key
                                            ))
                                        "
                                        class="d-flex align-items-center"
                                      >
                                        <input
                                          type="checkbox"
                                          :id="'zero_price_confirm_' + (index + 2)"
                                          class="me-2"
                                          style="margin-right: 5px"
                                          :checked="priceSetAsZero.includes(price.price_key)"
                                          @change="
                                            clearPriceError(
                                              index + 2,
                                              price.price_key,
                                              'price',
                                              $event
                                            )
                                          "
                                        />
                                        <label
                                          :for="'zero_price_confirm_' + (index + 2)"
                                          class="mb-0 text-muted small"
                                        >
                                          Set as $0
                                        </label>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr
                                  v-if="
                                    memberPriceSelected.hasOwnProperty(
                                      price.price_key
                                    )
                                  "
                                  style="border: none"
                                >
                                  <td colspan="2" style="border: none">
                                    <div class="text-blue" style="white-space: normal; word-wrap: break-word;">
                                      (Used as member price by
                                      {{
                                        memberPriceSelected[
                                          price.price_key
                                        ].join(", ")
                                      }})
                                    </div>
                                  </td>
                                </tr>
                              </template>
                            </template>
                          </tbody>
                        </table>
                      </div>
                      <div v-if="isEditItem" class="mt-2">
                        <div
                          class="tag-a-custom mt-3"
                          @click="showMorePrices = !showMorePrices"
                        >
                          {{ showMorePrices ? "Show Less" : "Show More" }}
                        </div>
                      </div>
                      <div
                        v-else-if="item.others_price.length < 9"
                        class="tag-a-custom mt-3"
                        @click="showAllPrice()"
                      >
                        Show All
                      </div>
                    </div>
                    <!-- By Weight (weighing scale) -->
                    <div class="mt-3">
                      <div class="d-flex justify-content-between align-items-center gap-3">
                        <div class="d-flex align-items-center">
                          <div class="me-2 fw-bold" style="color: #1871bd;">By Weight</div>
                          <div
                            :class="{ active: isByWeight }"
                            class="toggle_container"
                          >
                            <MaterialToggleButton
                              labelEnableText=""
                              labelDisableText=""
                              id="by_weight_toggle"
                              :defaultState="isByWeight"
                              v-on:change="triggerEventByWeight"
                              class="mb-0"
                              style="height: 25.5px !important;"
                            />
                          </div>
                        </div>
                        <div v-if="isByWeight" class="d-flex align-items-center">
                          <div class="me-2" style="white-space: nowrap;"><span class="fw-bold" style="color: #1871bd;">per Kg</span> $</div>
                          <material-input
                            @keydown.prevent.up="preventUpDown"
                            @keydown.prevent.down="preventUpDown"
                            v-model="item.price_per_kg"
                            type="number"
                            step="any"
                            id="price_per_kg"
                            name="price_per_kg"
                            size="lg"
                            :class="{ 'price-error': fieldRequired.isPricePerKgRequired }"
                          />
                        </div>
                      </div>
                      <span
                        class="is-invalid"
                        v-if="fieldRequired.isPricePerKgRequired"
                      >Per Kg price is required when By Weight is enabled.</span>
                    </div>
                    <!-- KSK064: kiosk-only display — struck-through "was" price and an icon badge on the item card. -->
                    <div class="mt-3">
                      <div class="fw-bold" style="color: #1871bd;">Kiosk Display</div>
                      <div class="d-flex align-items-center mt-2">
                        <div class="me-2" style="white-space: nowrap;">Strike-off price $</div>
                        <material-input
                          @keydown.prevent.up="preventUpDown"
                          @keydown.prevent.down="preventUpDown"
                          v-model="item.strike_price"
                          type="number"
                          step="any"
                          id="strike_price"
                          name="strike_price"
                          size="lg"
                          :class="{ 'price-error': fieldRequired.isStrikePriceInvalid }"
                        />
                      </div>
                      <div class="text-sm text-secondary mt-1">
                        Shown crossed out next to the item's price on the kiosk. Leave empty for none; only shown when higher than the price.
                      </div>
                      <span class="is-invalid" v-if="fieldRequired.isStrikePriceInvalid">Strike-off price must be 0 or more.</span>
                      <div class="mt-2 mb-1">Kiosk icon</div>
                      <KioskIconPicker v-model="item.kiosk_icon" />
                    </div>
                    <hr />
                    <div class="mt-3">
                      <div class="d-flex">
                        <h3 class="title-page fs-16 mb-0">DELIVERY PLATFORM</h3>
                        <div class="d-flex align-items-center justify-items-start ms-3">
                          <div
                            :class="{ active: isAllowZero }"
                            class="toggle_container"
                          >
                            <MaterialToggleButton
                              labelEnableText=""
                              labelDisableText=""
                              id="allow_zero_toggle"
                              :defaultState="isAllowZero"
                              v-on:change="triggerEventAllowZero"
                              class="mb-0"
                            />
                          </div>
                        </div>
                      </div>
                      <div v-if="isAllowZero">
                        <div class="table-responsive p-0 mt-3">
                          <table
                            class="table align-items-center mb-0 table-fixed"
                            style="border: none"
                          >
                            <thead style="border: none">
                              <tr style="border: none">
                                <th class="w-35" style="border: none">
                                  Platform Name
                                </th>
                                <th class="w-20" style="border: none">Price</th>
                              </tr>
                            </thead>
                            <tbody style="border: none">
                              <tr
                                v-for="(price, index) in isEditItem
                                  ? item.others_price_delivery_platform.slice(
                                      0,
                                      3
                                    )
                                  : item.others_price_delivery_platform"
                                :key="index"
                                style="border: none"
                                :class="{
                                  'price-row-error': platformPricesError.includes(
                                    price.price_key
                                  ),
                                }"
                              >
                                <td class="tex-end" style="border: none">
                                  <material-input
                                    v-model="price.description"
                                    :disabled="index < 3"
                                    type="text"
                                    :id="'price_description1_' + index"
                                    :name="'price_description1_' + index"
                                    @input="validatePlatformName(price, index)"
                                    class="ps-1"
                                  />
                                  <div v-if="errorsPlatformName[index]">
                                    <span class="is-invalid">{{
                                      errorsPlatformName[index]
                                    }}</span>
                                  </div>
                                  <div
                                    v-else-if="
                                      fieldPlatformRequired[index] &&
                                      fieldPlatformRequired[index].isNameRequired
                                    "
                                  >
                                    <span class="is-invalid"
                                      >The field is required.</span
                                    >
                                  </div>
                                </td>
                                <td
                                  class="tex-end"
                                  style="
                                    border: none;
                                    vertical-align: baseline !important;
                                  "
                                >
                                  <div
                                    style="
                                      display: flex;
                                      align-items: center;
                                      gap: 10px;
                                      flex-wrap: wrap;
                                    "
                                  >
                                    <div
                                      style="display: flex; align-items: center"
                                    >
                                      <div
                                        style="
                                          margin-bottom: 5px;
                                          margin-right: 5px;
                                        "
                                      >
                                        $
                                      </div>
                                      <material-input
                                        @keydown.prevent.up="preventUpDown"
                                        @keydown.prevent.down="preventUpDown"
                                        v-model="price.price"
                                        :id="'other_price1_' + index"
                                        :name="'other_price1_' + index"
                                        type="number"
                                        size="lg"
                                        :class="{
                                          'price-row-error': platformPricesError.includes(
                                            price.price_key
                                          ),
                                        }"
                                        @input="inputDeliveryPrice($event, index)"
                                      />
                                    </div>
                                    <div
                                      v-if="price.price == 0"
                                      class="d-flex align-items-center"
                                    >
                                      <input
                                        type="checkbox"
                                        :id="
                                          'zero_price_confirm_delivery_' + index
                                        "
                                        class="me-2"
                                        style="margin-right: 5px"
                                        :checked="platformPriceSetAsZero.includes(price.price_key)"
                                        @change="
                                          clearPriceError(
                                            index,
                                            price.price_key,
                                            'platformPrice',
                                            $event
                                          )
                                        "
                                      />
                                      <label
                                        :for="
                                          'zero_price_confirm_delivery_' + index
                                        "
                                        class="mb-0 text-muted small"
                                      >
                                        Set as $0
                                      </label>
                                    </div>
                                  </div>
                                </td>
                              </tr>

                              <template
                                v-if="
                                  isEditItem && showMoreDeliveryPlatformPrices
                                "
                              >
                                <tr
                                  v-for="(
                                    price, index
                                  ) in item.others_price_delivery_platform.slice(
                                    3
                                  )"
                                  :key="index + 3"
                                  style="border: none"
                                  :class="{
                                    'price-row-error': platformPricesError.includes(
                                      price.price_key
                                    ),
                                  }"
                                >
                                  <td class="tex-end" style="border: none">
                                    <material-input
                                      v-model="price.description"
                                      :disabled="(index + 3) < 3"
                                      type="text"
                                      :id="'price_description1_' + (index + 3)"
                                      :name="'price_description1_' + (index + 3)"
                                      @input="
                                        validatePlatformName(price, index + 3)
                                      "
                                      class="ps-1"
                                    />
                                    <div v-if="errorsPlatformName[index + 3]">
                                      <span class="is-invalid">{{
                                        errorsPlatformName[index + 3]
                                      }}</span>
                                    </div>
                                    <div
                                      v-else-if="
                                        fieldPlatformRequired[index + 3] &&
                                        fieldPlatformRequired[index + 3]
                                          .isNameRequired
                                      "
                                    >
                                      <span class="is-invalid"
                                        >The field is required.</span
                                      >
                                    </div>
                                  </td>
                                  <td
                                    class="tex-end"
                                    style="
                                      border: none;
                                      vertical-align: baseline !important;
                                    "
                                  >
                                    <div
                                      style="
                                        display: flex;
                                        align-items: center;
                                        gap: 10px;
                                        flex-wrap: wrap;
                                      "
                                    >
                                      <div
                                        style="display: flex; align-items: center"
                                      >
                                        <div
                                          style="
                                            margin-bottom: 5px;
                                            margin-right: 5px;
                                          "
                                        >
                                          $
                                        </div>
                                        <material-input
                                          @keydown.prevent.up="preventUpDown"
                                          @keydown.prevent.down="preventUpDown"
                                          v-model="price.price"
                                          :id="'other_price1_' + (index + 3)"
                                          :name="'other_price1_' + (index + 3)"
                                          type="number"
                                          step="any"
                                          size="lg"
                                          :class="{
                                            'price-row-error': platformPricesError.includes(
                                              price.price_key
                                            ),
                                          }"
                                          @input="
                                            inputDeliveryPrice($event, index + 3)
                                          "
                                        />
                                      </div>
                                      <div
                                        v-if="price.price == 0"
                                        class="d-flex align-items-center"
                                      >
                                        <input
                                          type="checkbox"
                                          :id="
                                            'zero_price_confirm_delivery_more_' +
                                            (index + 3)
                                          "
                                          class="me-2"
                                          style="margin-right: 5px"
                                          :checked="platformPriceSetAsZero.includes(price.price_key)"
                                          @change="
                                            clearPriceError(
                                              index,
                                              price.price_key,
                                              'platformPrice',
                                              $event
                                            )
                                          "
                                        />
                                        <label
                                          :for="
                                            'zero_price_confirm_delivery_more_' +
                                            (index + 3)
                                          "
                                          class="mb-0 text-muted small"
                                        >
                                          Set as $0
                                        </label>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                        <div v-if="isEditItem" class="mt-2">
                          <div
                            class="tag-a-custom mt-3"
                            @click="
                              showMoreDeliveryPlatformPrices = !showMoreDeliveryPlatformPrices
                            "
                          >
                            {{
                              showMoreDeliveryPlatformPrices
                                ? "Show Less"
                                : "Show More"
                            }}
                          </div>
                        </div>
                        <div
                          v-else-if="
                            item.others_price_delivery_platform.length < 9
                          "
                          class="tag-a-custom mt-3"
                          @click="addMorePriceDeliveryPlatform()"
                        >
                          Add More Price
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr v-if="isEditItem" />
                </div>
              </div>
              <div
                v-if="isRetailMode"
                id="cost-section"
                :class="'mb-80px'"
              >
                <div class="content-center">
                  <div
                    class="d-flex align-items-center justify-content-between mt-3 cursor-pointer section-header"
                    @click="showHideSection(3)"
                  >
                    <h3 class="title-page fs-16 mb-0">Cost and Suppliers</h3>
                  </div>
                  <div >
                    <div>
                      <div class="table-responsive p-0 mt-3">
                        <table
                          class="table align-items-center mb-0"
                          style="border: none"
                        >
                          <tbody style="border: none">
                            <tr>
                              <th class="tex-end" style="border: none">
                                Cost per Unit
                              </th>
                              <td style="border: none">
                                <div class="d-flex justify-content-between" >
                                  <div
                                    style="display: flex; align-items: center"
                                  >
                                    <material-input
                                      v-model="item.inventory_properties.cost_per_unit"
                                      type="number"
                                      step="any"
                                      size="lg"
                                    />
                                  </div>
                                  <div
                                    class="d-flex align-items-end"
                                  >
                                    <a
                                      class="text-decoration-underline tag-a-custom"
                                    >
                                      Add supplier
                                    </a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="pos-setting-section">
                <div class="content-center">
                  <div
                    class="d-flex align-items-center justify-content-between mt-3 cursor-pointer section-header"
                    @click="showHideSection(3)"
                  >
                    <h3 class="title-page fs-16 mb-0">POS Setting</h3>
                    <i
                      style="font-size: 32px"
                      class="material-icons cursor-pointer"
                    >
                      {{
                        showPosSettingSection ? "expand_less" : "expand_more"
                      }}
                    </i>
                  </div>
                  <div v-if="showPosSettingSection">
                    <div class="mt-3">
                      <label class="fw-bold" for>
                        Item Type
                        <span class="text-danger ms-2">*</span>
                      </label>
                      <Multiselect
                        v-model="item.type"
                        :options="itemTypes"
                        placeholder="Select item type"
                        :canClear="false"
                      />
                    </div>
                    <div class="mt-3">
                      <label class="fw-bold" for>
                        Item Mode
                        <span class="text-danger ms-2">*</span>
                      </label>
                      <Multiselect
                        v-model="item.item_type"
                        :options="itemTypes2"
                        placeholder="Select item mode"
                        :canClear="false"
                      />
                    </div>
                    <div class="mt-3">
                      <label class="fw-bold" for> Barcode </label>
                      <material-input
                        v-model="item.barcode"
                        type="text"
                        id="barcode"
                        name="barcode"
                      />
                    </div>
                    <div class="mt-3">
                      <label class="fw-bold" for> Barcode 2 </label>
                      <material-input
                        v-model="item.barcode2"
                        type="text"
                        id="barcode2"
                        name="barcode2"
                      />
                    </div>
                    <div class="mt-3">
                      <label class="fw-bold" for>
                        Order Printer (Kitchen Printing, KDS, Order List)
                      </label>
                      <Multiselect
                        v-model="item.printer_ids"
                        mode="tags"
                        :close-on-select="true"
                        :searchable="true"
                        :options="printerOptions"
                        placeholder="Select Printer"
                        :canClear="false"
                        @change="onPrinterChange"
                      />
                    </div>
                    <div v-if="!isRetailMode" class="mt-3">
                      <div
                        class="d-flex align-items-center justify-content-between mb-2"
                      >
                        <label class="fw-bold mb-0" for>Report Group</label>
                        <a
                          @click="gotoTypeAndGroupPage()"
                          class="text-decoration-underline tag-a-custom"
                          >Manage</a
                        >
                      </div>
                      <!-- ✅ CHANGE 6: Report Group in POS Setting stacks on mobile -->
                      <div class="d-flex flex-column flex-sm-row gap-2">
                        <Multiselect
                          v-model="item.type_id"
                          :options="types"
                          :canClear="false"
                          placeholder="Type"
                          @change="selectType"
                        />
                        <Multiselect
                          v-model="item.group_id"
                          :options="groups"
                          :canClear="false"
                          placeholder="Group"
                          :disabled="!item.type_id"
                        />
                      </div>
                    </div>
                    <!-- <div class="mt-3">
                      <label class="fw-bold" for> Inventory </label>
                      <Multiselect
                        v-model="item.is_inventory"
                        :options="inventories"
                        :canClear="false"
                        placeholder="Inventory"
                        :disabled="isInventoryItem"
                      />
                    </div> -->
                    <!-- ✅ CHANGE 7: POS Button/Font use col-12 col-sm-6 to stack on very narrow screens -->
                    <div class="row mt-3">
                      <div class="col-12 col-sm-6 d-flex align-items-center mb-2 mb-sm-0">
                        <label class="fw-bold mb-0 me-3" for>
                          POS Button
                        </label>
                        <color-input
                          v-model="item.button_color"
                          format="hex"
                          position="right bottom"
                        />
                      </div>
                      <div class="col-12 col-sm-6 d-flex align-items-center">
                        <label class="fw-bold mb-0 me-3" for>
                          POS Item Font
                        </label>
                        <color-input
                          v-model="item.font_color"
                          format="hex"
                          position="right bottom"
                        />
                      </div>
                    </div>
                    <div class="mt-3">
                      <label class="fw-bold" for> Button Position </label>
                      <div class="d-flex">
                        <material-input
                          @keydown.prevent.up="preventUpDown"
                          @keydown.prevent.down="preventUpDown"
                          v-model="item.button_position"
                          id="button_position"
                          name="button_position"
                          extraClass="p-2"
                          type="number"
                          size="lg"
                          :disabled="true"
                        />
                      </div>
                      <span
                        class="is-invalid"
                        v-if="fieldRequired.isItemButtonPositionRequired"
                        >Number must be greater than or equal to 0.</span
                      >
                    </div>
                    <div class="mt-3">
                      <label class="fw-bold" for>Tags & allergens</label>
                      <Multiselect
                        :createOption="true"
                        :searchable="true"
                        :mode="'tags'"
                        v-model="item.tags"
                        :options="tagList"
                        :canClear="false"
                        placeholder="Enter some Tags & allergens"
                      />
                    </div>
                  </div>
                  <hr />
                </div>
              </div>

              <div
                v-if="!isRetailMode"
                id="choice-section"
                :class="[isActiveChoice ? 'mb-80px' : 'mb-550px']"
              >
                <div class="content-center">
                  <div
                    class="d-flex align-items-center justify-content-between mt-3 cursor-pointer section-header"
                    @click="showHideSection(4)"
                  >
                    <h3 class="title-page fs-16 mb-0">Items Mode</h3>
                    <i
                      style="font-size: 32px"
                      class="material-icons cursor-pointer"
                    >
                      {{ showChoiceSection ? "expand_less" : "expand_more" }}
                    </i>
                  </div>
                  <div v-if="showChoiceSection">
                    <div class="mt-3">
                      <label class="fw-bold mb-0" for>Items Mode</label>
                      <Multiselect
                        v-model="itemMode"
                        :options="itemModes"
                        :canClear="false"
                        :searchable="false"
                        placeholder="Select Items Mode"
                        @change="onChangeItemMode"
                      />
                    </div>
                    <div
                      v-if="itemMode === 'choice'"
                      style="font-size: 14px; color: #007bff"
                      class="mt-3"
                    >
                      Enable choices for this product, such as:
                      <br />
                      Item 1: À La Carte
                      <br />
                      Item 2: Set Meal
                      <div class="mt-3">
                        Once enabled, the choice price will override the prices
                        set in the MAIN section above. You need to define
                        existing items for each choice under each choice.
                      </div>
                    </div>
                    <div v-if="itemMode === 'sub_category'" class="mt-3">
                      <label class="fw-bold mb-0 d-block" for>Attached Items</label>
                      <div v-if="subCategoryItems.length > 1" class="text-blue mt-1" style="font-size: 12px">
                        Drag to reorder. This order is used on the ordering screen.
                      </div>
                      <draggable
                        v-model="subCategoryItems"
                        item-key="item_no"
                        handle=".sub-category-drag-handle"
                        ghost-class="sub-category-ghost"
                      >
                        <template #item="{ element: subItem, index: subIndex }">
                          <div
                            class="d-flex align-items-center justify-content-between border rounded p-2 mt-2"
                          >
                            <span class="d-flex align-items-center">
                              <i
                                class="material-icons sub-category-drag-handle me-2"
                                style="font-size: 20px; color: #999; cursor: move"
                                title="Drag to reorder"
                                >drag_indicator</i
                              >
                              {{ subItem.item_no
                              }}{{
                                subItem.item_name ? " - " + subItem.item_name : ""
                              }}
                            </span>
                            <i
                              class="material-icons text-danger cursor-pointer ms-2"
                              style="font-size: 20px"
                              @click="removeSubCategoryItem(subIndex)"
                              title="Remove item"
                              >close</i
                            >
                          </div>
                        </template>
                      </draggable>
                      <material-button
                        class="btn btn-sm btn-background mt-2"
                        :disabled="!menusetId"
                        @click="openSubCategoryItemsModal()"
                      >
                        Add Items
                      </material-button>
                      <div v-if="!menusetId" class="text-blue mt-1">
                        Please select a menu set first.
                      </div>
                    </div>
                    <div v-if="itemMode === 'choice'" style="font-size: 14px !important">
                      <div
                        class="mt-3"
                        v-for="(choice, index) in item.choice_list"
                        :key="index"
                      >
                        <div class="d-flex align-items-center justify-content-between">
                          <label class="fw-bold mb-0" for>
                            Item  {{ index + 1 }}
                          </label>
                          <span
                            v-if="item.choice_list.length > 2"
                            class="text-danger cursor-pointer"
                            style="font-size: 13px"
                            @click="removeChoice(index)"
                          >
                            <i class="material-icons" style="font-size: 18px; vertical-align: middle;">close</i>
                            Remove
                          </span>
                        </div>
                        <div
                          v-for="(item, index2) in choice.items"
                          :key="index2"
                        >
                          <!-- ✅ CHANGE 5: Move "Linked Item No:" to the top under "Item N" -->
                          <div class="row mt-3">
                            <div class="col-12 col-sm-8 d-flex align-items-center mb-2 mb-sm-0">
                              <div style="min-width: 110px">
                                Linked Item No:
                              </div>
                              <material-input
                                v-model="item.item_no"
                                type="text"
                                :id="'item_no_' + index + '_' + index2"
                                :name="'item_no_' + index + '_' + index2"
                                @input="inputItemNo()"
                              />
                            </div>
                            <div class="col-12 col-sm-4 d-flex align-items-center">
                              <div class="me-2">Qty:</div>
                              <material-input
                                v-model="item.qty"
                                type="text"
                                :id="'qty_' + index + '_' + index2"
                                :name="'qty_' + index + '_' + index2"
                              />
                              <i
                                class="material-icons text-danger cursor-pointer ms-2"
                                style="font-size: 20px"
                                @click="removeItemFromChoice(index, index2)"
                                title="Remove item"
                              >close</i>
                            </div>
                          </div>
                        </div>
                        <!-- ✅ CHANGE 3: Inside the Sub Category section change each "Choice N" to "Item N" -->
                        <div class="d-flex flex-column flex-sm-row align-items-sm-center gap-2 mt-3">
                          <div class="flex-shrink-0">
                            Name: <span class="text-danger ms-2">*</span>
                          </div>
                          <material-input
                            v-model="choice.name"
                            type="text"
                            :id="'choice_name_' + index"
                            :name="'choice_name_' + index"
                            class="w-100"
                          />
                        </div>
                        <span
                          class="is-invalid"
                          v-if="
                            fieldChoiceRequired[index] &&
                            fieldChoiceRequired[index].isNameRequired
                          "
                          >The field is required.</span
                        >
                        <div class="d-flex flex-column flex-sm-row align-items-sm-center gap-2 mt-3">
                          <div class="flex-shrink-0">Default Price:</div>
                          <material-input
                            @keydown.prevent.up="preventUpDown"
                            @keydown.prevent.down="preventUpDown"
                            v-model="choice.default_price"
                            type="number"
                            :id="'choice_default_price_' + index"
                            :name="'choice_default_price_' + index"
                            class="w-100"
                          />
                        </div>
                        <div class="d-flex flex-column flex-sm-row align-items-sm-center gap-2 mt-3">
                          <div class="flex-shrink-0">Member Price:</div>
                          <material-input
                            @keydown.prevent.up="preventUpDown"
                            @keydown.prevent.down="preventUpDown"
                            v-model="choice.member_price"
                            type="number"
                            :id="'choice_member_price_' + index"
                            :name="'choice_member_price_' + index"
                            class="w-100"
                          />
                        </div>

                        <!-- Scheduled Price: set in ModalChoicePriceSchedules, saved with the item. -->
                        <div class="d-flex flex-column flex-sm-row align-items-sm-center gap-2 mt-3">
                          <div class="flex-shrink-0">Scheduled Price:</div>
                          <button
                            type="button"
                            class="btn btn-sm capitalize btn-background mb-0 choice-schedule-btn"
                            title="Set a price for a period"
                            @click="openChoicePriceSchedules(index)"
                          >
                            <i class="material-icons choice-schedule-btn__icon">schedule</i>
                            Schedule
                            <span
                              class="choice-schedule-btn__state"
                              :class="{ 'choice-schedule-btn__state--on': choice.price_schedules_enabled == 1 }"
                              >{{ choicePriceScheduleSummary(choice) }}</span
                            >
                          </button>
                        </div>

                        <div
                          class="tag-a-custom mt-3"
                          @click="addMoreItemToChoice(index)"
                        >
                          Add More Item
                        </div>
                        <hr class="mt-3 mb-0" />
                      </div>
                      <div
                        v-if="item.choice_list.length < 8"
                        class="tag-a-custom mt-3"
                        @click="addMoreChoice"
                      >
                        Add More Choice
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                id="inventory-section"
                v-if="
                  (isEditItem || isInventoryItem) &&
                  item.is_inventory == CLOUD_INVENTORY &&
                  false
                "
              >
                <div class="content-center">
                  <div
                    class="d-flex align-items-center justify-content-between mt-3 cursor-pointer section-header"
                    @click="showHideSection(5)"
                  >
                    <h3 class="title-page fs-16 mb-0">INVENTORY PROPERTIES</h3>
                    <i
                      style="font-size: 32px"
                      class="material-icons cursor-pointer"
                    >
                      {{ showInventorySection ? "expand_less" : "expand_more" }}
                    </i>
                  </div>
                </div>
              </div>
              <div
                id="inventory-section"
                class="mb-80px"
                v-if="
                  (isEditItem || isInventoryItem) &&
                  item.is_inventory == CLOUD_INVENTORY &&
                  false
                "
              >
                <div class="content-center" style="max-width: 90%">
                  <div v-if="showInventorySection" class="mt-3">
                    <hr />
                    <h3 class="title-page fs-16 mb-0">
                      General Inventory Properties
                    </h3>
                    <div class="row">
                      <div class="col-lg-6 col-12 row align-items-center">
                        <div class="col-5 d-flex justify-content-end">
                          <label class="fw-bold mb-0">Base UOM</label>
                        </div>
                        <div class="col-7">
                          <material-input
                            v-model="item.inventory_properties.base_uom"
                            type="text"
                            id="base_uom"
                            name="base_uom"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12 row align-items-center">
                        <div class="col-5 d-flex justify-content-end">
                          <label class="fw-bold mb-0">Selling UOM</label>
                        </div>
                        <div class="col-7">
                          <material-input
                            v-model="item.inventory_properties.selling_uom"
                            type="text"
                            id="selling_uom"
                            name="selling_uom"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6 col-12 row align-items-center">
                        <label class="col-5 text-end fw-bold mb-0"
                          >Conversion Rate <br />
                          (Base/Selling)</label
                        >
                        <div class="col-7">
                          <material-input
                            v-model="item.inventory_properties.coversion_rate"
                            type="number"
                            id="coversion_rate"
                            name="coversion_rate"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6 col-12 row align-items-center">
                        <label class="col-5 text-end fw-bold mb-0"
                          >Price excl. Tax</label
                        >
                        <div class="col-7">
                          <material-input
                            v-model="item.inventory_properties.price_excl_tax"
                            type="number"
                            id="price_excl_tax"
                            name="price_excl_tax"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12 row align-items-center">
                        <label class="col-5 text-end fw-bold mb-0"
                          >Cost per Unit</label
                        >
                        <div class="col-7">
                          <material-input
                            v-model="item.inventory_properties.cost_per_unit"
                            type="number"
                            id="cost_per_unit"
                            name="cost_per_unit"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6 col-12 row align-items-center">
                        <label class="col-5 text-end fw-bold mb-0"
                          >Profit %</label
                        >
                        <div class="col-7">
                          <material-input
                            v-model="calculationProfit"
                            type="number"
                            id="profit"
                            name="profit"
                            :disabled="true"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6 col-12 row align-items-center">
                        <div class="col-5 d-flex justify-content-end">
                          <label class="fw-bold mb-0">Stock Type</label>
                        </div>
                        <div class="col-7">
                          <Multiselect
                            v-model="item.inventory_properties.stock_type"
                            :options="stockTypes"
                            :canClear="false"
                            placeholder="Stock Type"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-4 text-center">
                        <label class="text-center fw-bold">Low Stock QTY</label>
                        <material-input
                          v-model="item.inventory_properties.low_stock_qty"
                          type="number"
                          id="low_stock_qty"
                          name="low_stock_qty"
                        />
                      </div>
                      <div class="col-4 text-center">
                        <label class="text-center fw-bold"
                          >High Stock QTY</label
                        >
                        <material-input
                          v-model="item.inventory_properties.high_stock_qty"
                          type="number"
                          id="high_stock_qty"
                          name="high_stock_qty"
                        />
                      </div>
                      <div class="col-4 text-center">
                        <label class="text-center fw-bold">Re-order QTY</label>
                        <material-input
                          v-model="item.inventory_properties.reorder_qty"
                          type="number"
                          id="reorder_qty"
                          name="reorder_qty"
                        />
                      </div>
                    </div>
                    <hr />
                    <h3 class="title-page fs-16 mb-0">
                      For Accounting/ERP Software
                    </h3>
                    <div class="row">
                      <div class="col-lg-6 col-12 row align-items-center">
                        <label class="col-5 text-end fw-bold mb-0"
                          >Cost of Sales Expense</label
                        >
                        <div class="col-7">
                          <material-input
                            v-model="
                              item.inventory_properties.cost_of_sales_expense
                            "
                            type="text"
                            id="cost_of_sales_expense"
                            name="cost_of_sales_expense"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12 row align-items-center">
                        <label class="col-5 text-end fw-bold mb-0"
                          >Sales Account</label
                        >
                        <div class="col-7">
                          <material-input
                            v-model="item.inventory_properties.sales_account"
                            type="text"
                            id="sales_account"
                            name="sales_account"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6 col-12 row align-items-center">
                        <label class="col-5 text-end fw-bold mb-0"
                          >Inventory Asset Account</label
                        >
                        <div class="col-7">
                          <material-input
                            v-model="
                              item.inventory_properties.inventory_asset_account
                            "
                            type="text"
                            id="inventory_asset_account"
                            name="inventory_asset_account"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="note">
                      <div
                        class="note-icon"
                        style="width: 20px; height: 20px; margin-top: 0"
                      >
                        !
                      </div>
                      <div>
                        Note: a tracked inventory item must have 3 accounts
                        selected.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ✅ CHANGE 10: footer stacks vertically on mobile -->
          <div class="modal-footer">
            <div
              class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2 w-100"
              :class="{
                'justify-content-sm-between': item.last_updated,
                'justify-content-sm-end': !item.last_updated
              }"
            >
              <div v-if="item.last_updated" class="updated-box">Last updated: {{ formatDate(item.last_updated) }}</div>
              <div class="d-flex ms-sm-auto">
                <material-button
                  class="mx-2 btn btn-sm btn-background"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Cancel
                </material-button>
                <material-button
                  style="
                    background-color: #1871bd !important;
                    color: white !important;
                    border-color: #1871bd !important;
                  "
                  class="mx-2 btn btn-sm btn-background"
                  @click="saveItem()"
                >
                  {{ isEditItem ? "Save" : "Add Item" }}
                </material-button>
              </div>
            </div>
          </div>

          <material-loading :active="loaderActive" />
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <AddOptionGroup
      :keyReload="keyReloadModalAddOptionGroup"
      :setId="menusetId"
      :itemId="isEditItem"
      :groupIdsSelect="groupIdsSelect"
      :groupsSelect="groupsSelect"
      @handle-add-option-group="handleAddOptionGroup"
    ></AddOptionGroup>
    <ModalNotification :message="errorNotificationMessage" />
    <ModalSelectSubCategoryItem
      :keyReload="keyReloadSubCategoryItem"
      :menusetId="menusetId"
      :selectedItems="subCategoryItems"
      @add-sub-category-items="onAddSubCategoryItems"
    />
    <ModalChoicePriceSchedules ref="choicePriceSchedules" @apply="onApplyChoicePriceSchedules" />
  </div>
</template>
<script>
import $ from "jquery";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import ItemService from "../services/product/item.service";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import ColorInput from "vue-color-input";
import MaterialToggleButton from "@/components/MaterialToggleButton.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import AddOptionGroup from "@/components/AddOptionGroup.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import Modal from "bootstrap/js/dist/modal";
import ModalNotification from "@/components/ModalNotification.vue";
import ModalSelectSubCategoryItem from "@/components/ModalSelectSubCategoryItem.vue";
import ModalChoicePriceSchedules from "@/components/ModalChoicePriceSchedules.vue";
import draggable from "vuedraggable";
import MaterialTextarea from "@/components/MaterialTextarea.vue";
import KioskIconPicker from "@/components/KioskIconPicker.vue";
import { CLOUD_INVENTORY, scrollToFirstInvalid } from "@/config/utils";

export default {
  name: "AddItemInventory",
  components: {
    KioskIconPicker,
    MaterialInput,
    MaterialButton,
    MaterialLoading,
    MaterialSnackbar,
    ColorInput,
    MaterialToggleButton,
    Multiselect,
    AddOptionGroup,
    ModalNotification,
    ModalSelectSubCategoryItem,
    ModalChoicePriceSchedules,
    draggable,
    MaterialTextarea,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    menusetId: {
      type: Number,
      default: 0,
    },
    categoryId: {
      type: Number,
      default: 0,
    },
    groupId: {
      type: Number,
      default: 0,
    },
    subGroupId: {
      type: Number,
      default: 0,
    },
    isEditItem: {
      type: Number,
      default: 0,
    },
    displayOrder: {
      type: Number,
      default: 0,
    },
    isInventoryItem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoadData: false,
      snackbar: null,
      message: "",
      urlImagePreview: null,
      // SH027 — the bookable windows of a salon service, replacing the Service & Slot Setting
      // screen. The three vocabularies below mirror MintyItemBookingSlot's constants.
      bookingSlots: [],
      bookingDayOptions: [
        { value: 9, label: "Everyday" },
        { value: 7, label: "Weekday" },
        { value: 8, label: "Weekend" },
        { value: 1, label: "Monday" },
        { value: 2, label: "Tuesday" },
        { value: 3, label: "Wednesday" },
        { value: 4, label: "Thursday" },
        { value: 5, label: "Friday" },
        { value: 6, label: "Saturday" },
        { value: 0, label: "Sunday" },
      ],
      bookingSlotStatusOptions: [
        { value: 0, label: "Deactive" },
        { value: 1, label: "Bookable" },
      ],
      bookingAdvanceUnitOptions: [
        { value: 1, label: "minutes" },
        { value: 2, label: "hours" },
        { value: 3, label: "days" },
      ],
      messageImageError: "",
      fieldRequired: [],
      isActive: true,
      isRetailMode: false,
      isEligibleBCRS: false,
      isAllowZero: false,
      isByWeight: false,
      isShowPosName: false,
      isShowBarcode: false,
      checkArrow: false,
      checkArrowTable: false,
      loaderActive: false,
      branchIdSelectDelete: 0,
      keyReloadModalAddOptionGroup: "key-reload-modal-add-option-group",
      groupIdsSelect: [],
      groupsSelect: [],
      groups: [],
      dataGroupByType: [],
      types: [],
      tags: [
        {
          label: "Cheese",
          value: 1,
        },
        {
          label: "Seafood",
          value: 2,
        },
      ],
      itemTypes: [
        {
          label: "Menu Item",
          value: 1,
        },
        {
          label: "Modifier",
          value: 2,
        },
        {
          label: "Group",
          value: 3,
        },
        {
          label: "Inventory",
          value: 4,
        },
        {
          label: "Sub Category",
          value: 5,
        },
        {
          label: "Charge",
          value: 6,
        },
        {
          label: "Discount",
          value: 7,
        },
      ],
      itemTypes2: [
        {
          label: "Fixed Price",
          value: 0,
        },
        {
          label: "By Price",
          value: 1,
        },
        {
          label: "By Weight",
          value: 2,
        },
        {
          label: "By Quantity",
          value: 3,
        },
        {
          label: "Set Menu",
          value: 4,
        },
        {
          label: "Multiple Price",
          value: 5,
        },
      ],
      diningOptionLabel: ["All", "Dine in", "Takeaway"],
      item: {
        item_no: "",
        item_name: "",
        image: null,
        description: "",
        printer_ids: [0],
        choice: 0,
        is_sub_category: 0,
        choice_list: [
          {
            id: 0,
            name: "",
            default_price: 0,
            member_price: 0,
            items: [
              {
                id: 0,
                item_no: "",
                qty: 0,
              },
              {
                id: 0,
                item_no: "",
                qty: 0,
              },
              {
                id: 0,
                item_no: "",
                qty: 0,
              },
            ],
          },
          {
            name: "",
            default_price: 0,
            member_price: 0,
            items: [
              {
                id: 0,
                item_no: "",
                qty: 0,
              },
              {
                id: 0,
                item_no: "",
                qty: 0,
              },
              {
                id: 0,
                item_no: "",
                qty: 0,
              },
            ],
          },
        ],
        pos_name: "",
        pos_description: "",
        item_name4: "",
        // SF289 — official item-name translations (see AddItem MAIN tab).
        item_name_zh: "",
        item_name_ja: "",
        item_name_ko: "",
        item_name_th: "",
        barcode: "",
        barcode2: "",
        price: 0,
        min_order_qty: 0,
        max_order_qty: 1,
        service_duration_min: 0,
        // SH027 — how far ahead this service may be booked, and the terms shown before the
        // customer confirms. Unit 3 = days, matching MintyItemBookingSlot::ADVANCE_TIME_UNIT.
        booking_min_advance_time: 0,
        booking_min_advance_time_unit: 3,
        booking_max_advance_time: 0,
        booking_max_advance_time_unit: 3,
        booking_terms_conditions: "",
        is_disabled: false,
        type: 1,
        item_type: 0,
        group_id: 0,
        type_id: 0,
        button_color: "#1871bd",
        font_color: "#1871bd",
        button_position: 0,
        others_price: [],
        others_price_delivery_platform: [],
        delivery_tax: 0,
        takeaway_tax: 0,
        eat_in_tax: 0,
        category_id: this.categoryId,
        menuset_id: this.menusetId,
        group_item_id: this.groupId,
        sub_group_item_id: this.subGroupId,
        is_buy_one_get_one_free: false,
        is_by_weight: false,
        price_per_kg: 0,
        kiosk_icon: null,
        strike_price: "",
        tag: 0,
        tags: [],
        modifier_option_group_ids: [],
        same_item_name: true,
        same_item_description: true,
        is_inventory: CLOUD_INVENTORY,
        inventory_properties: {
          base_uom: "Unit",
          selling_uom: "Unit",
          coversion_rate: 1,
          price_excl_tax: 0,
          cost_per_unit: 0,
          profit: 0,
          stock_type: "",
          low_stock_qty: 0,
          high_stock_qty: 0,
          reorder_qty: 0,
          cost_of_sales_expense: 0,
          sales_account: 0,
          inventory_asset_account: 0,
        },
      },
      categories: [],
      fieldChoiceRequired: [
        {
          isNameRequired: false,
        },
        {
          isNameRequired: false,
        },
      ],
      fieldPlatformRequired: [
        {
          isNameRequired: false,
        },
        {
          isNameRequired: false,
        },
        {
          isNameRequired: false,
        },
      ],
      typeTab: 1,
      tagList: [],
      errorsPlatformName: [],
      isActiveChoice: false,
      // The choice ModalChoicePriceSchedules is editing.
      choicePriceScheduleIndex: null,
      itemMode: "normal",
      subCategoryItems: [],
      keyReloadSubCategoryItem: "key-reload-sub-category-item",
      existingItemNos: [],
      itemNosLoaded: false,
      itemModes: [
        {
          value: "normal",
          label: "Normal Item",
        },
        {
          value: "sub_category",
          label: "Sub Category",
        },
        {
          value: "choice",
          label: "Choice",
        },
      ],
      showMorePrices: false,

      showMoreDeliveryPlatformPrices: false,
      printers: [],
      showPosSettingSection: false,
      showChoiceSection: false,
      showInventorySection: false,
      memberPriceSelected: [],
      menuSet: {},
      isChangeTab: false,
      errorNotificationMessage: "",
      inventories: [
        {
          value: 0,
          label: "NIL",
        },
        {
          value: 1,
          label: "Cloud Inventory",
        },
        {
          value: 2,
          label: "Local Inventory (POS only)",
        },
      ],
      stockTypes: [
        {
          value: 1,
          label: "Standard",
        },
        {
          value: 2,
          label: "TNI",
        },
        {
          value: 3,
          label: "UNT",
        },
      ],
      CLOUD_INVENTORY,
      pricesError: [],
      platformPricesError: [],
      priceSetAsZero: [],
      platformPriceSetAsZero: [],
    };
  },
  computed: {
    calculationProfit() {
      return this.item.others_price?.[0]?.price == 0
        ? 0
        : parseFloat(
            (this.item.inventory_properties.price_excl_tax -
              this.item.inventory_properties.cost_per_unit) /
              (this.item.others_price?.[0]?.price || 1)
          ).toFixed(2);
    },
    printerOptions() {
      return [
        { value: 0, label: "Use category setting" },
        ...this.printers,
      ];
    },
    isChoiceOrSubCategory() {
      return this.itemMode === "choice" || this.itemMode === "sub_category";
    },
    // SH027 — only a timed service is bookable, so only then is there a slot to configure.
    // This modal is also the Add/Edit form for modifier options and inventory items, and
    // neither of those is ever booked.
    isBookableService() {
      return Number(this.item.service_duration_min) > 0;
    },
  },
  methods: {
    // SH027 — one empty row, ready to be filled in. Everyday and Deactive are the safe
    // defaults: a slot only becomes bookable once the merchant says so.
    addBookingSlot() {
      this.bookingSlots.push({
        day_of_week: 9,
        name: "",
        start_time: "",
        end_time: "",
        status: 0,
        fieldRequired: {
          isNameRequire: false,
          isTimeRequire: false,
        },
      });
    },

    removeBookingSlot(index) {
      this.bookingSlots.splice(index, 1);
    },

    /**
     * "09:30:00" as the "09:30" a type="time" input takes. Anything unparseable becomes an
     * empty input rather than a value the browser silently drops.
     */
    toBookingTimeInput(value) {
      if (!value) {
        return "";
      }

      const parts = String(value).split(":");

      if (parts.length < 2) {
        return "";
      }

      return `${String(parts[0]).padStart(2, "0")}:${String(parts[1]).padStart(2, "0")}`;
    },

    /**
     * SH027 — hand the slot table to the API alongside the item.
     *
     * `booking_slots_submitted` says "this request owns the slot list": items are also saved
     * by imports and bulk screens that know nothing about slots, and the API must not read
     * their silence as "delete them all". An emptied table is dropped entirely by FormData,
     * so the flag is what carries "the merchant removed every slot".
     */
    applyBookingSlotsToItem() {
      if (!this.isBookableService) {
        // The section is not on screen, so this save says nothing about slots. A service
        // switched back to duration 0 keeps its slots for when it is switched back.
        delete this.item.booking_slots;
        delete this.item.booking_slots_submitted;
        return;
      }

      this.item.booking_slots_submitted = 1;
      this.item.booking_slots = this.bookingSlots.map((slot, index) => ({
        name: slot.name,
        day_of_week: slot.day_of_week,
        start_time: slot.start_time,
        end_time: slot.end_time,
        display_order: index,
        status: slot.status,
      }));
    },

    /**
     * Every slot row needs a name and both ends of its window. Mirrors the API's rules, which
     * reject the whole item save otherwise.
     */
    validateBookingSlots() {
      let isValid = true;

      this.bookingSlots.forEach((slot) => {
        slot.fieldRequired.isNameRequire = false;
        slot.fieldRequired.isTimeRequire = false;

        if (!slot.name) {
          slot.fieldRequired.isNameRequire = true;
          isValid = false;
        }

        if (!slot.start_time || !slot.end_time) {
          slot.fieldRequired.isTimeRequire = true;
          isValid = false;
        }
      });

      return isValid;
    },

    /**
     * The slot rows the API returned, in the shape the table edits.
     */
    setBookingSlots(slots) {
      this.bookingSlots = (slots || []).map((slot) => ({
        day_of_week: Number(slot.day_of_week),
        name: slot.name ?? "",
        start_time: this.toBookingTimeInput(slot.start_time),
        end_time: this.toBookingTimeInput(slot.end_time),
        status: Number(slot.status),
        fieldRequired: {
          isNameRequire: false,
          isTimeRequire: false,
        },
      }));
    },

    onPrinterChange(value) {
      if (!value || value.length === 0) {
        return;
      }
      if (value.length > 1) {
        if (value[value.length - 1] === 0) {
          // User selected "Use category setting" last → remove all others
          this.$nextTick(() => {
            this.item.printer_ids = [0];
          });
        } else if (value.includes(0)) {
          // User selected a specific printer → remove "Use category setting"
          this.$nextTick(() => {
            this.item.printer_ids = value.filter((v) => v !== 0);
          });
        }
      }
    },
    clearPriceError(index, price_key, type, event) {
      const status = event.target.checked;

      if (status) {
        if (type == "price") {
          this.priceSetAsZero.push(price_key);
          this.pricesError = this.pricesError.filter(
            (key) => key !== price_key
          );
        } else if (type == "platformPrice") {
          this.platformPriceSetAsZero.push(price_key);
          this.platformPricesError = this.platformPricesError.filter(
            (key) => key !== price_key
          );
        }
      } else {
        if (type == "price") {
          this.priceSetAsZero = this.priceSetAsZero.filter(
            (key) => key !== price_key
          );
          if (this.item.others_price[index].price == 0) {
            this.pricesError.push(price_key);
          }
        } else if (type == "platformPrice") {
          this.platformPriceSetAsZero = this.platformPriceSetAsZero.filter(
            (key) => key !== price_key
          );
          if (this.item.others_price_delivery_platform[index].price == 0) {
            this.platformPricesError.push(price_key);
          }
        }
      }
    },
    changeTab(type, id) {
      this.isChangeTab = true;
      this.typeTab = type;
      $("#general-tab .nav-edit-item").removeClass("active");
      $("#nav_edit_item_" + type).addClass("active");

      if (id == "pos-setting-section") {
        this.showPosSettingSection = true;
      } else if (id == "choice-section") {
        this.showChoiceSection = true;
      } else if (id == "inventory-section") {
        this.showInventorySection = true;
      }

      const $container = $(".modal-body");
      const $target = $("#" + id);

      if ($target.length) {
        const relativeTop = $target[0].offsetTop;

        $container.animate(
          {
            scrollTop: relativeTop - 75,
          },
          500
        );
      }

      setTimeout(() => {
        this.isChangeTab = false;
      }, 500);
    },

    showHideSection(section) {
      if (section == 3) {
        this.showPosSettingSection = !this.showPosSettingSection;

        if (this.showPosSettingSection) {
          this.changeTab(3, "pos-setting-section");
        }
      } else if (section == 4) {
        this.showChoiceSection = !this.showChoiceSection;

        if (this.showChoiceSection) {
          this.changeTab(4, "choice-section");
        }
      } else if (section == 6) {
        this.showInventorySection = !this.showInventorySection;

        if (this.showInventorySection) {
          this.changeTab(6, "inventory-section");
        }
      } else {
        this.changeTab(
          section,
          section == 1 ? "main-section" : "prices-section"
        );
      }
    },

    handleScroll(event) {
      if (this.isChangeTab) {
        return;
      }

      let sections = [
        "main-section",
        "prices-section",
        "pos-setting-section",
        "choice-section"
      ];

      if (!this.isEditItem) {
        sections = ["main-section", "prices-section"];
      }

      const scrollPosition = event.target.scrollTop + 100;

      sections.forEach((section, index) => {
        if (section) {
          const $section = $(`#${section}`);
          if ($section.length) {
            const sectionTop = $section[0].offsetTop;
            const sectionBottom = sectionTop + $section[0].offsetHeight;

            // If scrolled to bottom, activate the last item by default
            if (
              Math.round(
                event.target.scrollHeight - event.target.scrollTop + 0.5
              ) === event.target.clientHeight
            ) {
              $("#general-tab .nav-edit-item").removeClass("active");
              $(
                `#nav_edit_item_${
                  4
                }`
              ).addClass("active");
              return;
            } else {
              if (
                scrollPosition >= sectionTop &&
                scrollPosition < sectionBottom
              ) {
                $("#general-tab .nav-edit-item").removeClass("active");
                $(`#nav_edit_item_${index + 1}`).addClass("active");
              }
            }
          }
        }
      });
    },

    hideEditItem() {
      this.$emit("hide-edit-item");
    },

    handleChangeTag(tags) {
      this.item.tags = tags;
    },
    uploadFile(id) {
      $("#" + id).click();
    },

    clearImage() {
      this.item.image = null;
      this.urlImagePreview = null;
      this.fieldRequired.isImageRequire = false;
    },

    handleFileUpload(event) {
      this.errorNotificationMessage = "";
      let file = event.target.files[0];
      if (file != null || file != undefined) {
        this.item.image = null;
        this.urlImagePreview = null;

        if (
          !["image/png", "image/jpg", "image/jpeg", "image/svg"].includes(
            file.type
          )
        ) {
          this.fieldRequired.isImageRequire = true;
          this.messageImageError = `File must be an image.`;
          this.errorNotificationMessage = `File must be an image.<br>`;
        } else {
          const maxFileSize = 1024 * 1024; // 1MB
          if (file.size > maxFileSize) {
            this.fieldRequired.isImageRequire = true;
            this.messageImageError = `File size must not exceed 1MB.`;
            this.errorNotificationMessage = `File size must not exceed 1MB.<br>`;
          } else {
            this.item.image = file;
            this.urlImagePreview = URL.createObjectURL(file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (evt) => {
              let img = new Image();
              img.onload = () => {
                let width = img.width;
                let height = img.height;
                if (width < 100 || height < 100) {
                  this.messageImageError = `The image width ${width} x ${height} is too small.`;
                  this.errorNotificationMessage = `The image width ${width} x ${height} is too small.<br>`;
                  this.fieldRequired.isImageRequire = true;
                } else {
                  this.fieldRequired.isImageRequire = false;
                  this.messageImageError = "";
                }
              };
              img.src = evt.target.result;
            };
          }
        }

        if (this.errorNotificationMessage != "") {
          this.showErrorNotification();
        }
      } else {
        this.item.image = null;
        this.urlImagePreview = null;
        this.messageImageError = "";
      }
      $("#image-item")[0].value = "";
    },

    clearFormData() {
      // SH027 — the slot table lives outside `item`, so it has to be cleared by hand or the
      // previous service's slots show up on the next item opened in this modal.
      this.bookingSlots = [];
      this.item = {
        item_no: "",
        item_name: "",
        image: null,
        description: "",
        printer_ids: [0],
        choice: 0,
        is_sub_category: 0,
        choice_list: [
          {
            id: 0,
            name: "",
            default_price: 0,
            member_price: 0,
            items: [
              {
                id: 0,
                item_no: "",
                qty: 0,
              },
              {
                id: 0,
                item_no: "",
                qty: 0,
              },
              {
                id: 0,
                item_no: "",
                qty: 0,
              },
            ],
          },
          {
            id: 0,
            name: "",
            default_price: 0,
            member_price: 0,
            items: [
              {
                id: 0,
                item_no: "",
                qty: 0,
              },
              {
                id: 0,
                item_no: "",
                qty: 0,
              },
              {
                id: 0,
                item_no: "",
                qty: 0,
              },
            ],
          },
        ],
        pos_name: "",
        pos_description: "",
        item_name4: "",
        // SF289 — official item-name translations (see AddItem MAIN tab).
        item_name_zh: "",
        item_name_ja: "",
        item_name_ko: "",
        item_name_th: "",
        barcode: "",
        barcode2: "",
        price: 0,
        min_order_qty: 0,
        max_order_qty: 1,
        service_duration_min: 0,
        // SH027 — how far ahead this service may be booked, and the terms shown before the
        // customer confirms. Unit 3 = days, matching MintyItemBookingSlot::ADVANCE_TIME_UNIT.
        booking_min_advance_time: 0,
        booking_min_advance_time_unit: 3,
        booking_max_advance_time: 0,
        booking_max_advance_time_unit: 3,
        booking_terms_conditions: "",
        is_disabled: false,
        type: 1,
        item_type: 0,
        group_id: 0,
        type_id: 0,
        button_color: "#1871bd",
        font_color: "#1871bd",
        button_position: 0,
        others_price: [],
        others_price_delivery_platform: [],
        delivery_tax: 0,
        takeaway_tax: 0,
        eat_in_tax: 0,
        category_id: this.categoryId,
        menuset_id: this.menusetId,
        group_item_id: this.groupId,
        sub_group_item_id: this.subGroupId,
        is_buy_one_get_one_free: false,
        is_by_weight: false,
        price_per_kg: 0,
        kiosk_icon: null,
        strike_price: "",
        modifier_option_group_ids: [],
        tag: 0,
        tags: [],
        same_item_name: true,
        same_item_description: true,
        is_inventory: CLOUD_INVENTORY,
        inventory_properties: {
          base_uom: "Unit",
          selling_uom: "Unit",
          coversion_rate: 1,
          price_excl_tax: 0,
          cost_per_unit: 0,
          profit: 0,
          stock_type: 1,
          low_stock_qty: 0,
          high_stock_qty: 0,
          reorder_qty: 0,
          cost_of_sales_expense: 0,
          sales_account: 0,
          inventory_asset_account: 0,
        },
      };
      this.showMorePrices = false;
      (this.showMoreDeliveryPlatformPrices = false),
        (this.showPosSettingSection = false);
      this.showChoiceSection = false;
      this.showInventorySection = false;
      this.printers = [];
      this.groupsSelect = [];
      this.urlImagePreview = false;
      this.memberPriceSelected = [];
      this.menuSet = {};
      this.messageImageError = "";
      $("#image-item").val("");
      this.snackbar = null;
      this.message = "";
      this.changeTab(1, "main-section");
      this.pricesError = [];
      this.platformPricesError = [];
      this.priceSetAsZero = [];
      this.platformPriceSetAsZero = [];
      this.isActiveChoice = false;
      this.itemMode = "normal";
      this.subCategoryItems = [];
      this.isByWeight = false;
    },

    saveItem() {
      // Sub Category mode is saved as a single choice whose items are the selected item list,
      // flagged with is_sub_category.
      if (this.itemMode === "sub_category") {
        this.item.choice = 1;
        this.item.is_sub_category = 1;
        this.item.choice_list = [
          {
            id: 0,
            name: "",
            default_price: 0,
            member_price: 0,
            items: this.subCategoryItems.map((subItem) => ({
              id: 0,
              item_no: subItem.item_no || "",
              qty: 1,
            })),
          },
        ];
      } else {
        this.item.is_sub_category = 0;
      }

      // Choice mode owns each choice's scheduled prices: the flag tells the API to replace them,
      // since FormData drops an emptied list and other screens save items without schedules.
      if (this.itemMode === "choice") {
        this.item.choice_list.forEach((choice) => {
          choice.price_schedules = choice.price_schedules || [];
          choice.price_schedules_enabled = Number(choice.price_schedules_enabled) === 1 ? 1 : 0;
          choice.price_schedules_submitted = 1;
        });
      }

      // Choice / Sub Category items don't use the main price, so skip the $0 price check.
      if (this.isChoiceOrSubCategory) {
        this.pricesError = [];
        this.platformPricesError = [];
      } else {
        this.processValidatePrices();
      }

      if (this.pricesError.length > 0 || this.platformPricesError.length > 0) {
        this.errorNotificationMessage = "Please check the option to confirm that price is intentionally set to $0.<br>";
        this.showErrorNotification();

        if (this.pricesError.length > 0) {
          const hasError = this.pricesError.some(key => {
            const index = Number(key.replace('price_', ''));
            return index >= 3 && index <= 9;
          });

          if (hasError) {
            this.showMorePrices = true;
          }
        }

        if (this.platformPricesError.length > 0) {
          const hasError = this.platformPricesError.some(key => {
            const index = Number(key.replace('price_', ''));
            return index >= 3 && index <= 9;
          });

          if (hasError) {
            this.showMoreDeliveryPlatformPrices = true;
          }
        }

        const $container = $(".modal-body");
        const $target = $("#" + "prices-section");

        if ($target.length) {
          const relativeTop = $target[0].offsetTop;

          $container.animate(
            {
              scrollTop: relativeTop - 75,
            },
            500
          );
        }
        return;
      }

      // Choice / Sub Category: linked Item No must exist in the item list.
      if (this.isChoiceOrSubCategory && this.itemNosLoaded) {
        const missingItemNos = this.getMissingChoiceItemNos();
        if (missingItemNos.length > 0) {
          this.errorNotificationMessage =
            "The following Item No do not exist in the item list: " +
            missingItemNos.join(", ") +
            ".<br>";
          this.showErrorNotification();
          return;
        }
      }

      if (this.processValidate()) {
        this.showLoader();
        this.item.set_id = this.menusetId;
        this.item.modifier_option_groups = null;
        this.applyBookingSlotsToItem();
        this.item.category_id = this.categoryId;
        this.item.group_item_id = this.groupId;
        this.item.sub_group_item_id = this.subGroupId;
        this.item.inventory_properties.profit = this.calculationProfit;
        this.item.prices_set_as_zero = this.priceSetAsZero;
        this.item.platform_prices_set_as_zero = this.platformPriceSetAsZero;
        // KSK113 — axios drops null fields from FormData, so "None" never reached the API and the
        // old icon stayed. "" is sent instead; ConvertEmptyStringsToNull stores it as null.
        this.item.kiosk_icon = this.item.kiosk_icon || "";

        if (this.item.id > 0) {
          // update
          ItemService.update(this.item.id, this.item).then(
            (response) => {
              if (response.data.result.isSuccess) {
                this.snackbar = "success";
                this.message = "Update Item Success";
                this.setTimeOutNotification();
                this.$emit("reload-list-category");
                $("#hide-modal-add-item").click();
              } else {
                this.snackbar = "danger";
                this.message = response.data.result.message;
                this.setTimeOutNotification();
              }
              this.hideLoader();
            },
            (error) => {
              this.snackbar = "danger";
              this.message = error.response.data.result.message;
              this.hideLoader();
              this.setTimeOutNotification();
            }
          );
        } else {
          // add
          this.item.display_order = this.displayOrder
            ? this.displayOrder
            : this.item.button_position;

          ItemService.store(this.item).then(
            (response) => {
              if (response.data.result.isSuccess) {
                this.snackbar = "success";
                this.message = "Add Item Success";
                this.setTimeOutNotification();
                this.$emit("reload-list-category");
                $("#hide-modal-add-item").click();
              } else {
                this.snackbar = "danger";
                this.message = response.data.result.message;
                this.setTimeOutNotification();
              }
              this.hideLoader();
            },
            (error) => {
              this.snackbar = "danger";
              this.message = error.response.data.result.message;
              this.hideLoader();
              this.setTimeOutNotification();
            }
          );
        }
      } else {
        // processValidate() scrolls to the first field it flagged; only an error with no field
        // on screen falls back to the section it belongs to. Checked once the error texts are
        // rendered.
        this.$nextTick(() => {
          if (document.querySelector("#modalAddItem .is-invalid")) return;

          if (this.errorsPlatformName && this.errorsPlatformName.length > 0) {
            this.changeTab(2, "prices-section");
          } else {
            this.changeTab(1, "main-section");
          }
          $(".modal-body").scrollTop(0);
        });
      }
    },

    async getDataFilter() {
      var dataForm = {
        get_tags: 1,
        get_groups: 1,
        get_printers: 1,
        get_price_list: 1,
        get_price_list_delivery_platform: 1,
        set_id: this.menusetId,
        category_id: this.categoryId,
        group_id: this.groupId,
        subGroup_id: this.subGroupId,
        item_id: this.isEditItem ? this.isEditItem : 0,
      };

      await ItemService.getDataFilter(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;

            this.tagList = data.tags;
            this.types = data.types;
            this.dataGroupByType = data.groups;
            this.printers = data.printers;
            this.item.item_no = data.item_no;
            this.item.button_position = data.button_position;
            this.item.others_price = data.price_list;
            this.item.others_price_delivery_platform =
              data.price_list_delivery_platform;
            this.memberPriceSelected = data.member_price_selected;
            this.menuSet = data.menuset;

            if (!this.isEditItem) {
              this.item.others_price = data.price_list.slice(0, 2);

              this.item.others_price_delivery_platform = data.price_list_delivery_platform.slice(
                0,
                3
              );
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
    },

    selectType(value) {
      if (this.isLoadData) {
        this.item.group_id = 0;
      }

      this.groups = this.dataGroupByType[value];
    },

    async getItemDetail() {
      var dataForm = {
        set_id: this.menusetId,
        categoryId: this.categoryId,
        groupId: this.groupId,
        subGroupId: this.subGroupId,
      };

      await ItemService.itemDetail(this.isEditItem, dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.item = response.data.data;
            this.setBookingSlots(this.item.booking_slots);
            // If item has no printers, default to "Use category setting"
            if (!this.item.printer_ids || this.item.printer_ids.length === 0) {
              this.item.printer_ids = [0];
            }
            this.groups = this.dataGroupByType[this.item.type_id] ?? [];
            this.groupIdsSelect = this.item.modifier_option_group_ids;
            this.isActiveChoice = this.item.choice == 1 ? true : false;
            if (this.item.is_sub_category == 1) {
              this.itemMode = "sub_category";
              this.subCategoryItems =
                this.item.choice_list &&
                this.item.choice_list[0] &&
                this.item.choice_list[0].items
                  ? this.item.choice_list[0].items.map((it) => ({
                      item_id: it.item_id ?? null,
                      item_no: it.item_no,
                      item_name: it.item_name ?? "",
                    }))
                  : [];
            } else {
              this.itemMode = this.item.choice == 1 ? "choice" : "normal";
            }
            this.urlImagePreview = this.item.image;
            this.priceSetAsZero = this.item.prices_set_as_zero;
            this.platformPriceSetAsZero = this.item.platform_prices_set_as_zero;
            this.isEligibleBCRS = this.item.eligible_bcrs == 1 ? true : false;
            this.isByWeight = this.item.is_by_weight === true || this.item.is_by_weight == 1;

            if (this.item.choice) {
              this.showChoiceSection = true;
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
            this.hideLoader();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response.data.result.message;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    resetRequired() {
      this.errorNotificationMessage = "";
      this.fieldRequired.isBookingAdvanceTimeInvalid = false;
      this.fieldRequired.isItemNameNoRequired = false;
      this.fieldRequired.isItemNameRequired = false;
      this.fieldRequired.isPosNameRequired = false;
      this.fieldRequired.isItemMinOrderLimitRequired = false;
      this.fieldRequired.isItemMaxOrderLimitRequired = false;
      this.fieldRequired.isItemServiceDurationRequired = false;
      this.fieldRequired.isReportGroupRequired = false;
      this.fieldRequired.isPricePerKgRequired = false;
      this.fieldRequired.isStrikePriceInvalid = false;
      this.fieldChoiceRequired = this.item.choice_list.map(() => ({
        isNameRequired: false,
      }));
      // this.fieldRequired.isPrice1Required = false;
      // this.fieldRequired.isItemPriceRequired = false;
    },

    processValidatePrices() {
      this.item.others_price.forEach((price, index) => {
        if (
          price.price_key === "price_1" ||
          Object.prototype.hasOwnProperty.call(
            this.memberPriceSelected,
            price.price_key
          )
        ) {
          if (
            price.price == 0 &&
            !this.priceSetAsZero.includes(price.price_key)
          ) {
            this.pricesError.push("price_" + (index + 1));
          } else {
            this.pricesError = this.pricesError.filter(
              (key) => key !== "price_" + (index + 1)
            );
          }
        }
      });

      if (this.isAllowZero) {
        this.item.others_price_delivery_platform.forEach((price, index) => {
          if (
            price.price == 0 &&
            !this.platformPriceSetAsZero.includes(price.price_key)
          ) {
            this.platformPricesError.push("price_" + (index + 1));
          } else {
            this.platformPricesError = this.platformPricesError.filter(
              (key) => key !== "price_" + (index + 1)
            );
          }
        });
      } else {
        this.platformPricesError = [];
      }
    },

    processValidate() {
      this.resetRequired();
      var isValid = true;
      var scrollTop = false;

      if (this.item.item_no == "" || this.item.item_no == null) {
        scrollTop = true;
        this.fieldRequired.isItemNameNoRequired = true;
        isValid = false;
        this.errorNotificationMessage += `Item No is required.<br>`;
      }

      if (this.item.item_name == "" || this.item.item_name == null) {
        scrollTop = true;
        this.fieldRequired.isItemNameRequired = true;
        isValid = false;
        this.errorNotificationMessage += `Item Name is required.<br>`;
      }

      if (this.item.pos_name == "" || this.item.pos_name == null) {
        scrollTop = true;
        this.fieldRequired.isPosNameRequired = true;
        isValid = false;
        this.errorNotificationMessage += `Pos Name is required.<br>`;
      }

      if (this.item.button_position === "" || this.item.button_position < 0) {
        scrollTop = true;
        this.fieldRequired.isItemButtonPositionRequired = true;
        isValid = false;
        this.errorNotificationMessage += `Button Position is required.<br>`;
      }

      if (!this.item.printer_ids || this.item.printer_ids.length === 0) {
        isValid = false;
        this.errorNotificationMessage += `Order Printer is required.<br>`;
      }

      // Mirrors the backend rule (nullable|integer|min:0|max:1440). An emptied number
      // input hands back "", which the API rejects as a non-integer.
      const serviceDuration = this.item.service_duration_min;
      if (
        serviceDuration === "" ||
        serviceDuration === null ||
        serviceDuration === undefined ||
        Number(serviceDuration) < 0 ||
        Number(serviceDuration) > 1440
      ) {
        scrollTop = true;
        this.fieldRequired.isItemServiceDurationRequired = true;
        isValid = false;
        this.errorNotificationMessage += `Service duration must be between 0 and 1440 minutes.<br>`;
      }

      // SH027 — the booking window and its slots, only while the section is on screen.
      if (this.isBookableService) {
        const minAdvance = Number(this.item.booking_min_advance_time);
        const maxAdvance = Number(this.item.booking_max_advance_time);

        if (
          this.item.booking_min_advance_time === "" ||
          this.item.booking_max_advance_time === "" ||
          Number.isNaN(minAdvance) ||
          Number.isNaN(maxAdvance) ||
          minAdvance < 0 ||
          maxAdvance < 0
        ) {
          scrollTop = true;
          this.fieldRequired.isBookingAdvanceTimeInvalid = true;
          isValid = false;
          this.errorNotificationMessage += `Booking in advance time must be 0 or more.<br>`;
        }

        if (!this.validateBookingSlots()) {
          isValid = false;
          this.errorNotificationMessage += `Every booking slot needs a name and a start and end time.<br>`;
        }
      }

      if (this.isRetailMode) {
        if (!this.item.type_id || this.item.type_id === 0) {
          scrollTop = true;
          this.fieldRequired.isReportGroupRequired = true;
          isValid = false;
          this.errorNotificationMessage += `Report Group (Type) is required.<br>`;
        }
        if (!this.item.group_id || this.item.group_id === 0) {
          scrollTop = true;
          this.fieldRequired.isReportGroupRequired = true;
          isValid = false;
          this.errorNotificationMessage += `Report Group (Group) is required.<br>`;
        }
      }

      if (this.isByWeight) {
        const perKg = parseFloat(this.item.price_per_kg);
        if (!perKg || perKg <= 0 || isNaN(perKg)) {
          scrollTop = false;
          this.fieldRequired.isPricePerKgRequired = true;
          isValid = false;
          this.errorNotificationMessage += `Per Kg price is required when By Weight is enabled.<br>`;
        }
      }

      // KSK064 — mirrors the backend rule (nullable|numeric|min:0); empty = no strike-off price.
      const strikePrice = this.item.strike_price;
      if (strikePrice !== "" && strikePrice !== null && strikePrice !== undefined) {
        if (isNaN(parseFloat(strikePrice)) || parseFloat(strikePrice) < 0) {
          this.fieldRequired.isStrikePriceInvalid = true;
          isValid = false;
          this.errorNotificationMessage += `Strike-off price must be 0 or more.<br>`;
        }
      }

      if (
        this.errorsPlatformName &&
        this.errorsPlatformName.some(
          (error) => error !== null && error !== undefined
        )
      ) {
        isValid = false;
      }

      if (this.item.choice && this.itemMode !== "sub_category") {
        // Ensure fieldChoiceRequired is synced with choice_list length
        while (this.fieldChoiceRequired.length < this.item.choice_list.length) {
          this.fieldChoiceRequired.push({ isNameRequired: false });
        }
        
        if (this.fieldChoiceRequired.length > this.item.choice_list.length) {
          this.fieldChoiceRequired.splice(this.item.choice_list.length);
        }

        this.item.choice_list.map((choice, index) => {
          if (choice.name == "" || choice.name == null) {
            this.fieldChoiceRequired[index].isNameRequired = true;
            // The error sits in the Items Mode section, which may be collapsed.
            this.showChoiceSection = true;
            isValid = false;
            scrollTop = false;
            this.errorNotificationMessage += `Choice Name ${
              index + 1
            } is required.<br>`;
            return;
          } else {
            this.fieldChoiceRequired[index].isNameRequired = false;
          }
        });
      }

      // this.item.others_price_delivery_platform.map((price, index) => {
      //   if (price.description == "" || price.description == null) {
      //     this.showMoreDeliveryPlatformPrices = true;
      //     this.fieldPlatformRequired[index].isNameRequired = true;
      //     isValid = false;
      //     return;
      //   } else {
      //     this.fieldPlatformRequired[index].isNameRequired = false;
      //   }
      // });

      console.log("scrollTop", scrollTop);

      // if (!isValid) {
      //   if (scrollTop) {
      //     $(".modal-body").animate(
      //       {
      //         scrollTop: 0,
      //       },
      //       500
      //     );
      //   } else {
      //     $(".modal-body").animate(
      //       {
      //         scrollTop: $(".modal-body").height(),
      //       },
      //       500
      //     );
      //   }
      // }

      if (this.errorNotificationMessage != "") {
        this.showErrorNotification();
      }

      if (!isValid) {
        // The error popup opens on top of this modal, so search this modal itself.
        scrollToFirstInvalid(document.getElementById("modalAddItem"));
      }

      return isValid;
    },

    inputItemPrice(event, index) {
      const value = event.target.value;
      const priceKey = "price_" + (index + 1);

      this.item.others_price[index].price = value;

      const price = parseFloat(value);
      if (!isNaN(price) && price > 0) {
        this.pricesError = this.pricesError.filter((key) => key !== priceKey);
      } else if (value !== "" && parseFloat(value) <= 0) {
        const hasDecimalSeparator = value.includes(".") || value.includes(",");
        if (!hasDecimalSeparator) {
          this.item.others_price[index].price = "0";
          if (
            !this.priceSetAsZero.includes(priceKey) &&
            Object.prototype.hasOwnProperty.call(this.memberPriceSelected, priceKey)
          ) {
            this.pricesError.push(priceKey);
          }
        }
      }
    },

    inputDeliveryPrice(event, index) {
      const value = event.target.value;
      const priceKey = "price_" + (index + 1);

      this.item.others_price_delivery_platform[index].price = value;

      const price = parseFloat(value);

      if (!isNaN(price) && price > 0) {
        this.platformPricesError = this.platformPricesError.filter(
          (key) => key !== priceKey
        );
      } else if (value !== "" && parseFloat(value) <= 0) {
        const hasDecimalSeparator = value.includes(".") || value.includes(",");
        if (!hasDecimalSeparator) {
          this.item.others_price_delivery_platform[index].price = "0";
          if (!this.platformPriceSetAsZero.includes(priceKey)) {
            this.platformPricesError.push(priceKey);
          }
        }
      }
    },

    formatDate(date) {
      return new Date(date).toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },

    triggerEvent(value) {
      if (typeof value == "boolean") {
        this.item.is_disabled = !value;
      }
    },

    triggerEventChoice(value) {
      if (typeof value == "boolean") {
        this.isActiveChoice = !this.isActiveChoice;
        this.item.choice = this.isActiveChoice ? 1 : 0;
      }
    },

    async getExistingItemNos() {
      try {
        const response = await ItemService.getMainItem({});
        if (response.data.result.isSuccess) {
          const items = response.data.data.items || [];
          this.existingItemNos = items
            .map((it) => (it.item_no ?? "").toString().trim().toLowerCase())
            .filter((no) => no !== "");
          this.itemNosLoaded = true;
        }
      } catch (e) {
        // If the list can't be loaded, skip client-side validation and let the API validate.
        this.itemNosLoaded = false;
      }
    },

    // Return the linked Item No entered in choice/sub category that don't exist in the item list.
    getMissingChoiceItemNos() {
      const lookup = new Set(this.existingItemNos);
      const missing = [];
      (this.item.choice_list || []).forEach((choice) => {
        (choice.items || []).forEach((it) => {
          const raw = (it.item_no ?? "").toString().trim();
          if (raw === "") return;
          if (!lookup.has(raw.toLowerCase()) && !missing.includes(raw)) {
            missing.push(raw);
          }
        });
      });
      return missing;
    },

    openSubCategoryItemsModal() {
      if (!this.menusetId) return;
      this.keyReloadSubCategoryItem = Math.random().toString();
      this.showStackedModal("modalSelectSubCategoryItem");
    },

    // Show a modal on top of this one (sub category picker, choice scheduled prices).
    showStackedModal(modalId) {
      // Same proven pattern as addOptionGroup(): show the shared custom overlay
      // and open the picker via a Bootstrap Modal instance. Its own backdrop
      // sits below the AddItem modal, so AddItem stays visible and there is no
      // orphaned black backdrop on close.
      const overlay = document.getElementById("custom-overlay");
      overlay?.classList.add("show");
      const modalElement = document.getElementById(modalId);
      if (modalElement) {
        // This file loads two separate copies of Bootstrap's JS: the bundle
        // (for data-bs-toggle) and this component's own `Modal` import. Each
        // copy keeps its own isolated FocusTrap/EventHandler bookkeeping, so
        // AddItem's focus trap (from the bundle) has no way to know this
        // picker (opened via the other copy) exists — it keeps yanking focus
        // back into itself whenever the picker's inputs are focused, making
        // them unusable. Intercept focusin in the capture phase while the
        // picker is open so AddItem's (bubble-phase) trap handler never sees
        // focus events that land inside the picker.
        const guardPickerFocus = (event) => {
          if (modalElement.contains(event.target)) {
            event.stopPropagation();
          }
        };
        document.addEventListener("focusin", guardPickerFocus, true);

        const modal = new Modal(modalElement);
        modal.show();
        modalElement.addEventListener(
          "hidden.bs.modal",
          () => {
            overlay?.classList.remove("show");
            document.removeEventListener("focusin", guardPickerFocus, true);
          },
          { once: true }
        );
      }
    },

    // Append the picked items, skipping any Item No already in the list.
    onAddSubCategoryItems(selectedItems) {
      const existing = new Set(
        this.subCategoryItems.map((it) => (it.item_no ?? "").toString())
      );
      selectedItems.forEach((it) => {
        const itemNo = (it.item_no ?? "").toString();
        if (itemNo && !existing.has(itemNo)) {
          existing.add(itemNo);
          this.subCategoryItems.push({
            item_id: it.item_id ?? null,
            item_no: it.item_no,
            item_name: it.item_name ?? "",
          });
        }
      });
    },

    removeSubCategoryItem(index) {
      this.subCategoryItems.splice(index, 1);
    },

    onChangeItemMode(value) {
      this.itemMode = value;
      if (this.itemMode === "choice") {
        this.item.choice = 1;
        this.isActiveChoice = true;
      } else {
        // normal item + sub category keep the working state as a non-choice item;
        // sub category is converted into a choice payload on save.
        this.item.choice = 0;
        this.isActiveChoice = false;
      }
    },

    triggerEventFreeItem(value) {
      if (typeof value == "boolean") {
        this.item.is_buy_one_get_one_free = !value;
      }
    },

    triggerEventRetailMode(value) {
      if (typeof value == "boolean") {
        this.isRetailMode = value;
      }
    },

    triggerEventEligibleBCRS(value) {
      if (typeof value == "boolean") {
        this.isEligibleBCRS = value;
        this.item.eligible_bcrs = this.isEligibleBCRS ? 1 : 0;
      }
    },

    triggerEventAllowZero(value) {
      if (typeof value == "boolean") {
        this.isAllowZero = value;
      }
    },

    triggerEventByWeight(value) {
      if (typeof value == "boolean") {
        this.isByWeight = value;
        this.item.is_by_weight = value;
        if (!value) {
          this.item.price_per_kg = 0;
          this.fieldRequired.isPricePerKgRequired = false;
        }
      }
    },

    triggerEventPrice(index) {
      var value = $("#price-status-" + index + "_button").is(":checked");
      if (typeof value == "boolean") {
        this.item.others_price[index].status = !value;
      }
    },

    triggerEventAppliedPrice(index, index2, index3) {
      var value = $(
        "#modifier-status-" + index + "_" + index2 + "_" + index3 + "_button"
      ).is(":checked");
      if (typeof value == "boolean") {
        this.groupsSelect[index].modifier_option_group_section[index2].items[
          index3
        ].modifier_status = !value;
      }
    },

    addOptionGroup() {
      this.keyReloadModalAddOptionGroup = Math.random();
      const overlay = document.getElementById("custom-overlay");
      overlay?.classList.add("show");
      const modalElement = document.getElementById("addOptionGroup");
      if (modalElement) {
        const modal = new Modal(modalElement);
        modal.show();
        modalElement.addEventListener("hidden.bs.modal", () => {
          overlay?.classList.remove("show");
        });
      }
    },

    handleAddOptionGroup(ids, groups) {
      this.groupIdsSelect = ids;
      this.groupsSelect = groups;
      this.item.modifier_option_group_ids = ids;
    },

    preventUpDown(event) {
      // Check if the up or down arrow key was pressed
      if (event.keyCode === 38 || event.keyCode === 40) {
        // Prevent the default behavior of the key event
        event.preventDefault();
      }
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    gotoTypeAndGroupPage() {
      // $("#hide-modal-add-item").click();
      window.open("/report-group", "_blank");
    },

    checkboxChange(value, field = "name") {
      if (field == "name") {
        if (value) {
          this.item.pos_name = this.item.item_name.substring(0, 100);
        } else {
          this.item.pos_name = "";
        }
      }

      if (field == "description") {
        if (value) {
          this.item.pos_description = this.item.description;
        } else {
          this.item.pos_description = "";
        }
      }
    },

    inputItemNo() {
      if (!this.item.item_no) {
        return;
      }
      this.item.item_no = this.item.item_no.replace(/[^A-Za-z0-9\-_.]/g, "");
    },

    inputItemName() {
      this.item.item_name = this.item.item_name.substring(0, 50);

      if (this.menuSet) {
        if (this.menuSet.pos_name == 1) {
          this.item.pos_name = this.item.item_name;
        }

        if (this.menuSet.pos_description == 1) {
          this.item.pos_description = this.item.item_name;
        }
      } else {
        this.item.pos_name = this.item.item_name;
      }
    },

    inputItemDescription() {
      if (this.menuSet) {
        if (this.menuSet.pos_name == 2) {
          this.item.pos_name = this.item.description.substring(0, 100);
        }

        if (this.menuSet.pos_description == 2) {
          this.item.pos_description = this.item.description.substring(0, 100);
        }
      } else {
        this.item.pos_description = this.item.description.substring(0, 100);
      }
    },

    validatePlatformName(price, index) {
      // Check if the description exceeds 20 characters
      if (price.description.length > 20) {
        this.errorsPlatformName[index] = "Max 20 characters";
      } else {
        this.errorsPlatformName[index] = null;
      }
    },

    addMoreChoice() {
      if (this.item.choice_list.length >= 8) return;
      
      this.item.choice_list.push({
        id: 0,
        name: "",
        default_price: 0,
        member_price: 0,
        items: [
        ],
      });
      this.fieldChoiceRequired.push({ isNameRequired: false });
    },

    removeChoice(index) {
      if (this.item.choice_list.length <= 2) return;
      this.item.choice_list.splice(index, 1);
      this.fieldChoiceRequired.splice(index, 1);
    },

    addMoreItemToChoice(index) {
      this.item.choice_list[index].items.push({
        id: 0,
        item_no: "",
        qty: 0,
      });
    },

    removeItemFromChoice(choiceIndex, itemIndex) {
      this.item.choice_list[choiceIndex].items.splice(itemIndex, 1);
    },

    // Same wording as the Sales Channel "Schedule" button.
    choicePriceScheduleSummary(choice) {
      if (Number(choice.price_schedules_enabled) !== 1) {
        return "Off";
      }
      const count = (choice.price_schedules || []).filter((schedule) => schedule.status).length;
      return `On · ${count} schedule${count === 1 ? "" : "s"}`;
    },

    openChoicePriceSchedules(index) {
      const choice = this.item.choice_list[index];
      this.choicePriceScheduleIndex = index;
      this.$refs.choicePriceSchedules.open(choice.price_schedules, choice.price_schedules_enabled, choice.name);
      this.showStackedModal("modalChoicePriceSchedules");
    },

    onApplyChoicePriceSchedules({ enabled, rows }) {
      const choice = this.item.choice_list[this.choicePriceScheduleIndex];
      if (choice) {
        choice.price_schedules_enabled = enabled;
        choice.price_schedules = rows;
      }
    },

    showAllPrice() {
      for (let i = 3; i <= 9; i++) {
        const price = {
          id: i,
          price_key: "price_" + i,
          name: "PRICE " + i,
          description: "Price " + i,
          price: 0,
          status: 1,
        };

        this.item.others_price.push(price);
      }
    },

    addMorePriceDeliveryPlatform() {
      const index = this.item.others_price_delivery_platform.length + 1;
      const price = {
        id: index,
        price_key: "price_" + index,
        name: "PRICE " + index,
        description: "Plat" + index,
        price: 0,
        status: 1,
      };

      this.item.others_price_delivery_platform.push(price);
      this.fieldPlatformRequired.push({
        isNameRequired: false,
      });
    },

    showErrorNotification() {
      const overlay = document.getElementById("custom-overlay");
      overlay?.classList.add("show");
      const modalElement = document.getElementById("modalNotification");
      if (modalElement) {
        const modal = new Modal(modalElement);
        modal.show();
        modalElement.addEventListener("hidden.bs.modal", () => {
          overlay?.classList.remove("show");
        });
      }
    },
  },
  watch: {
    async keyReload() {
      this.showLoader();
      this.resetRequired();
      this.clearFormData();
      this.isLoadData = false;
      this.isRetailMode = this.isInventoryItem;
      this.isEligibleBCRS = false;
      this.isByWeight = false;
      if (this.menusetId !== 0) {
        this.isRetailMode = false;
      }
      this.fieldPlatformRequired = [
        {
          isNameRequired: false,
        },
        {
          isNameRequired: false,
        },
        {
          isNameRequired: false,
        },
      ];

      await this.getDataFilter();

      // Load the merchant item list (Item No) used to validate choice / sub category links.
      this.itemNosLoaded = false;
      this.getExistingItemNos();

      if (this.isEditItem) {
        this.fieldPlatformRequired = [
          {
            isNameRequired: false,
          },
          {
            isNameRequired: false,
          },
          {
            isNameRequired: false,
          },
          {
            isNameRequired: false,
          },
          {
            isNameRequired: false,
          },
          {
            isNameRequired: false,
          },
          {
            isNameRequired: false,
          },
          {
            isNameRequired: false,
          },
          {
            isNameRequired: false,
          },
        ];

        await this.getItemDetail();
      }

      this.hideLoader();
      this.isLoadData = true;
    },
  },
};
</script>
<style scoped>
/* Choice scheduled prices: the button that opens ModalChoicePriceSchedules, styled like the
   Sales Channel "Schedule" button. */
.choice-schedule-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  white-space: nowrap;
}
/* .btn-sm shrinks icons. */
.choice-schedule-btn .choice-schedule-btn__icon {
  font-size: 18px !important;
}
.choice-schedule-btn__state {
  padding: 2px 8px;
  border-radius: 10px;
  background: #e9ecef;
  color: #67748e;
  font-size: 11px;
  text-transform: none;
}
.choice-schedule-btn__state--on {
  background: #4caf50;
  color: #fff;
}
/* SH027 — the booking slot rows. The form column inside this modal is about 500px wide, so
   every control on the second line is sized to fit one line together. */
.booking-slot-section .booking-time {
  width: 118px;
  flex: 0 0 118px;
  padding: 6px 8px;
  border: 1px solid #d2d6da;
  border-radius: 6px;
}
/* flex-basis, not just max-width: each of these sits in a flex row beside a growing input,
   which otherwise shrinks the select until its label is clipped to "ho…". */
.booking-slot-section .booking-unit {
  flex: 0 0 120px;
  max-width: 120px;
}
.booking-slot-section .booking-slot-row {
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 8px;
}
.booking-slot-section .booking-day {
  flex: 0 0 150px;
  max-width: 150px;
}
.booking-slot-section .booking-status {
  flex: 0 0 145px;
  max-width: 145px;
}
.booking-slot-section .no-slot {
  color: #8f9bb3;
  border: 1px dashed #d2d6da;
  border-radius: 6px;
}
.sub-category-ghost {
  opacity: 0.5;
  background: #e9f3fb;
}
.table-fixed {
  table-layout: fixed;
}

th.w-20, td.w-20 {
  width: 20% !important;
}
.modal-body {
  min-height: 50vh;
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}
.modal-body .row {
  margin-top: 10px;
}
.modal-dialog {
  max-width: 950px;
}
.dowload-img {
  text-align: center;
  cursor: pointer;
  background-color: #f0f2f5;
  width: 150px;
  height: 150px;
  overflow-y: auto;
  position: relative;
}
.css-icon-upload {
  font-size: 45px !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.image-url {
  width: 150px;
  height: 150px;
  object-fit: cover;
}
.col-mg {
  margin-bottom: 20px;
}
.modal-width {
  min-width: 60%;
}
.float-right {
  float: right;
}
.float-left {
  float: left;
}
.icon-arrow {
  position: absolute;
  transform: translateY(-11px);
  font-size: 45px;
}
.tag-a-custom {
  color: #007bff !important;
  text-decoration: underline !important;
  cursor: pointer;
}
.btn-edit-img {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  color: #f44335;
  font-size: 14px;
  right: 30px;
  top: 4px;
  background: #ffffff;
  border-radius: 50%;
}
.cursor-pointer {
  cursor: pointer;
}
.price-box,
.modifier-box {
  border: 1px solid #d5d6d8;
  border-radius: 5px;
  padding: 15px 25px;
  margin: 30px 0;
}
.fs-16 {
  font-size: 16px !important;
}
.table-responsive thead tr th {
  padding: 0.5rem !important;
}
.mw-300px {
  max-width: 300px !important;
}
#general-tab .nav-item {
  width: calc(100% / 4);
  text-align: center;
}
.content-center {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}
label,
.form-label {
  margin-left: 0px !important;
  color: black;
}
.table-responsive thead tr th {
  padding-left: 0px !important;
}
.table > :not(caption) > * > * {
  padding-left: 0px !important;
}
.text-danger {
  color: red;
}
.text-blue {
  color: #007bff;
}
.section-header {
  background-color: #133067;
  height: 32px;
  color: #fff !important;
  padding-left: 10px;
  line-height: 32px;
}
.section-header .title-page,
.section-header i {
  color: #fff !important;
}
.is-invalid {
  font-size: 12px;
}
:deep(.input-group.input-group-dynamic .form-control) {
  background-image: none;
  border: 1px solid #d9d9d9 !important;
  padding: 8px !important;
  margin-bottom: 0;
}
.d-none {
  display: none !important;
}
.mb-550px {
  margin-bottom: 550px !important;
}
.mb-80px {
  margin-bottom: 80px !important;
}
:deep(#inventory-section input) {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.note {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 10px;
  margin: 20px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}
.note-icon {
  margin-top: 2px;
  width: 16px;
  height: 16px;
  background: #f39c12;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
}

/* Price error highlighting */
.price-error {
  border: 2px solid #dc3545 !important;
  background-color: #f8d7da !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.price-error:focus {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

/* Row error highlighting */
.price-row-error {
  background-color: #f8d7da !important;
  border-left: 4px solid #dc3545 !important;
}

/* Input error highlighting with stronger styles */
.price-error input {
  border: 2px solid #dc3545 !important;
  background-color: #f8d7da !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.modal-footer {
  display: unset !important;
  justify-content: unset !important;
  align-items: unset !important;
}

.updated-box {
  border: 1px solid #e5e7eb;   /* xám nhạt */
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  padding: 5px 10px;
}

/* Close (X) button always pinned to top-right corner of header */
.custom-modal-header {
  padding-right: 40px !important;
}
.modal-close-x {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 5;
  font-size: 22px;
  line-height: 1;
}

@media (max-width: 500px) {
  #general-tab {
    overflow-x: auto;
    width: 100% !important;
    overflow-y: hidden;
    flex-wrap: nowrap;
  }

  #general-tab .nav-item {
    min-width: 150px;
  }

  .menu-top {
    width: 100% !important;
  }

  .item-image-container {
    flex-direction: column;
    flex-direction: column-reverse;
  }

  .item-image-container > div:first-child {
    margin-top: 1rem;
  }

  /* Fit modal within mobile screen height */
  #modalAddItem .modal-dialog {
    margin: 0.5rem;
    max-height: calc(100vh - 1rem);
  }
  #modalAddItem .modal-content {
    max-height: calc(100vh - 1rem);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  #modalAddItem .modal-header {
    flex-shrink: 0;
    padding: 10px 40px 10px 14px;
  }
  #modalAddItem .modal-footer {
    flex-shrink: 0;
  }
  #modalAddItem .modal-body {
    flex: 1 1 auto;
    min-height: 0 !important;
    max-height: none !important;
    overflow-y: auto;
  }
  .modal-close-x {
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    font-size: 20px;
  }
}
</style>